import React from "react";
import {
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBNotification,
  MDBInputGroup,
  toast,
  MDBFormInline,
  MDBBadge,
  MDBAnimation,
  ToastContainer,
  MDBIcon,
  MDBDataTable,
  MDBAlert,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtnGroup,
} from "mdbreact";
import { XInput, XSelect, XBtn, XDatePicker } from "../../Components/XForm";
import Loader from "../../Components/Loader";
import { API_OP_CONFIG } from "../../Config/config-env.js";
import { API_CONFIG, casaideas_credentials } from "../../Config/config-env.js";
import { OP_SECRET_KEY } from "../../Config/config-env.js";
//import HelloWorld from '../../Components/HelloWorld/HelloWorld.js';
import axios from "axios";
//para picking individual
import {
  applyExternalDarkMode,
  getCasaIdeasStores,
  getStoreCodeByOfficeCode,
  parseCurrencyToNumber,
  instanteBolivia,
  normalizeOfficeCode,
} from "../../Config/functions";
import BarcodeScanner from "../../Components/BarcodeScanner";
import LockOverlay from "../../Components/LockOverlay";

class externalForm06 extends React.Component {
  state = {
    modal5: false,
    id_producto: -1,
    mensaje: "",
    modal6: false,
    opcion: "",
    modal7: false,
    username: "",
    accion: "",
    crossStoreWarning: null,
    tarjeta_1: "",
    tarjeta_2: "",
    modal34: false,
    isDeleted: false,
    anulacion_invoice_status: "PENDIENTE",
    showProductsList: true,
    productQty: 1,
    formButtons: [],
    anulacion_invoice_response: "",
    productName: "",
    productImageBig: "",
    SKUcode: "", //"3212567000066",
    intento_facturacion: "0",
    productPrice: 0,
    productImage: "",
    existingPreviousOrder: false,
    isExecuting: false,
    taskName: "",
    searchResults: [],
    shippingTypes: [],
    paymentTypes: [],
    monto_total: 0,
    from_date: new Date(),
    cupon_interno: "",
    metodo_pago_2: "",
    metodo_pago: "",
    monto_2: "",
    monto_real: "",
    processing: "Procesando",
    pedido_parcial: "NO",
    // HU06 Preventa parcial -- "stock" = esta ejecucion es la Rama A
    // (flowBolCI01, items con stock real), que nunca factura aca aunque
    // tipo_envio sea "weight" -- la factura la hace la Rama B
    // (flowBolCI09) cuando junta lo que llego de preventa. Default "" se
    // comporta igual que antes (cualquier valor != "stock" factura normal).
    branch_name: "",
    ordersPre: [
      {
        id: 0,
        product_id: 111,
        productName: "Manta",
        productPrice: "50Bs.",
        productQty: "1",
        state: "loaded",
      },
      {
        id: 1,
        product_id: 112,
        productName: "Juego de Tazas",
        productPrice: "50Bs.",
        productQty: "1",
        state: "loaded",
      },
    ],
    motivo: "",
    motivos: [
      { text: "Producto sin stock", value: "1" },
      { text: "Pedido no entregado", value: "2" },
      { text: "Cambio método de envío", value: "3" },
      { text: "Edición de pedido", value: "4" },
      { text: "Solicita cancelar pedido", value: "5" },
      { text: "Refacturación por cierre de mes", value: "6" },
      { text: "Falla en producto", value: "7" },
      { text: "No era lo que esperaba", value: "8" },
      { text: "Prueba Sistemas", value: "9" },
      { text: "Nit no corresponde", value: "10" },
      { text: "Confusión de precios", value: "11" },
      { text: "Error de precio", value: "12" },
      { text: "Error de cajero", value: "13" },
      { text: "Otro", value: "14" },
    ],
    tipos_documento: [
      {
        text: "Cédula de Identidad",
        value: "Cédula de Identidad",
        codigo: "1",
      },
      {
        text: "Cédula de Identidad de Extranjero",
        value: "Cédula de Identidad de Extranjero",
        codigo: "2",
      },
      { text: "Pasaporte", value: "Pasaporte", codigo: "3" },
      {
        text: "Otro Documento de Identidad",
        value: "Otro Documento de Identidad",
        codigo: "4",
      },
      {
        text: "Número de Identificación Tributaria",
        value: "Número de Identificación Tributaria",
        codigo: "5",
      },
    ],
    orders: [],
    isSupervisor: -1,
    isAdmin: -1,
    shippId: 1,
    WO_Id: "",
    WO_TaskId: "",
    payId: "",
    store_url: "",
    isLoadedTable: false,
    loadingData: true,
    modal4: false,
    modal3: false,
    modal33: false,
    order_id: "",
    orderName: "order_id",
    preventaMap: {},
    // HU06 Preventa -- loadPreventaStatus es async y se dispara "fire and
    // forget" al final de LoadTable (no se espera antes de habilitar los
    // Pick). Sin esta bandera, un click hecho ANTES de que resuelva pasa
    // el gate de handlePick igual: preventaMap[sku] === false evalua
    // undefined === false -> false -> no bloquea. Confirmado en vivo
    // (2026-09-23, pedido 690, flow 692): un pick automatizado justo tras
    // cargar la tarea coló el item de preventa (picking_products_i quedo
    // con ambos SKUs, progress_i=100). Mientras preventaMapLoaded sea
    // false, handlePick bloquea CUALQUIER pick (no solo el de preventa) --
    // mismo criterio conservador ya usado en TASKID18/modo_preventa_origen
    // ("mejor un gate de mas que uno de menos").
    preventaMapLoaded: false,
    orderPrice: "Bs.50",
    orderQty: "1",
    customerName: "",
    customerAdd: "",
    customerZone: "",
    productMaxQty: 0,
    disabledAdd: true,
    costo_envio: 0,
    descuento: 0,
    invoice_status: "PENDIENTE",
    invoice_response: "",

    pre_costo_envio: 0,
    pre_descuento: 0,

    sub_total: 0,
    org: "",
    store_id: 0,
    read_sku: "",
    observacion: "",
    TRX: "",
    posicion_rack: "",
    numero_factura: "",
    razon_social: "",
    nit: "",
    direccion_1: "",
    direccion_2: "",
    latitude: "",
    longitude: "",
    telefono: "",
    customer_id: "",
    reload: false,
    mixed_skus: [],
    skus: [],

    metodos: [],
    metodos_orig: [
      { text: "EFECTIVO", value: "EFECTIVO", checked: false },
      { text: "EFECTIVO ME", value: "EFECTIVO ME", checked: false },

      { text: "TARJETA ATC", value: "TARJETA ATC", checked: false },
      { text: "TARJETA LINKSER", value: "TARJETA LINKSER", checked: false },
      { text: "QR ATC", value: "QR ATC", checked: false },
      {
        text: "LINEA DE CREDITO IISA",
        value: "LINEA DE CREDITO IISA",
        checked: false,
      },
      { text: "TODOTIX", value: "TODOTIX", checked: false },
      { text: "QR BCP", value: "QR BCP", checked: false },

      { text: "CONTRAENTREGA", value: "CONTRAENTREGA", checked: false },
    ],
    metodos2: [
      { text: "NINGUNO", value: "", checked: true },
      { text: "TARJETA ATC", value: "TARJETA ATC", checked: false },
      { text: "TARJETA LINKSER", value: "TARJETA LINKSER", checked: false },
      { text: "QR ATC", value: "QR ATC", checked: false },
      {
        text: "LINEA DE CREDITO IISA",
        value: "LINEA DE CREDITO IISA",
        checked: false,
      },
      { text: "TODOTIX", value: "TODOTIX", checked: false },
      { text: "QR BCP", value: "QR BCP", checked: false },

      { text: "CONTRAENTREGA", value: "CONTRAENTREGA", checked: false },
    ],
    locked: false,
  };

  getPickerValueFrom = (value) => {
    this.setState({ from_date: value });
  };

  componentDidMount = async () => {
    await this.LoadTable();
  };

  selectHandler1 = (event) => {
    if (event[0]) {
      this.setState({ ...this.state, shippId: event[0] });
    } else {
      this.setState({ ...this.state, shippId: "" });
    }
  };

  selectHandler2 = (event) => {
    if (event[0]) {
      this.setState({ ...this.state, payId: event[0] });
    } else {
      this.setState({ ...this.state, payId: "" });
    }
  };

  selectHandler3 = (event) => {
    if (event[0]) {
      this.setState({ ...this.state, metodo_pago: event[0] });
    } else {
      this.setState({ ...this.state, metodo_pago: "" });
    }
  };

  selectHandler34 = (event) => {
    //console.log("dato"+event[0])
    if (event[0]) {
      this.setState({ ...this.state, motivo: event[0] });
    } else {
      this.setState({ ...this.state, motivo: "" });
    }
  };
  selectHandler4 = (event) => {
    //console.log("dato"+event[0])
    if (event[0]) {
      this.setState({ ...this.state, metodo_pago_2: event[0] });
    } else {
      this.setState({ ...this.state, metodo_pago_2: "" });
    }

    if (event[0] == "") {
      this.setState({ ...this.state, metodo_pago_2: "", monto_2: "" });
    }
  };

  selectHandler5 = (event) => {
    if (event[0]) {
      this.setState({ ...this.state, tipo_documento: event[0] });
    } else {
      this.setState({ ...this.state, tipo_documento: "" });
    }
  };

  anulateInvoice = async (bypass) => {
    if (this.state.locked) return;
    let anulacion_invoice_response, anulacion_invoice_status, TRX;
    let url = API_CONFIG.xflowurl + "/engine-users/save-flow-field";

    let responseValidation = true;
    let numero_factura = this.state.numero_factura;
    let invoice_status = this.state.invoice_status;
    let invoice_response = this.state.invoice_response;
    if (this.state.motivo === "") {
      responseValidation = false;
      toast.warning("Debe completar el Motivo", {
        closeButton: true,
      });
    }
    if (responseValidation) {
      this.setState({ isExecuting: true });

      let InvoiceData = {
        componentcode: "anulacionXflow",
        ventaId: this.state.TRX,
        motivoId: this.state.motivo,
        codUsuario: this.state.invoice_user,
        id_pedido: this.state.order_id,
      };
      let response = {};

      await axios({
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.token,
        },
        url: API_CONFIG.xflowurl + "/engine-users/execute-api",
        //url : "http://localhost:4042/api/v1"+"/engine-users/execute-api",
        data: InvoiceData,
        method: "post",
      })
        .then((response) => response.data)
        .then((data) => {
          response = data;
        });
      //console.log("response", response);

      if (!response.status) {
        anulacion_invoice_response = "Error en la anulación";
        anulacion_invoice_status = "EJECUTADO CON ERROR";

        toast.error(anulacion_invoice_response, {
          closeButton: true,
        });

        if (!response.resp1.status) {
          //console.log("ERROR API Anulacion de pedido", response.resp1);
          anulacion_invoice_response = response.resp1.data;
          this.setState({
            datos_enviados:
              "....DATOS PEDIDO:..." + JSON.stringify(response.data),
          });
          try {
            anulacion_invoice_response =
              response.resp1.data.ErrorInfoExt.errorMsg +
              ".Código:" +
              response.resp1.data.ErrorInfoExt.errorCode;
          } catch (e) {
            //console.log("error por default");
            anulacion_invoice_response = response.resp1.message;
          }
        }
      } else {
        //console.log("OK");
        numero_factura = "";
        TRX = "0";
        invoice_response = "";
        anulacion_invoice_response = "Factura anulada correctamente";
        anulacion_invoice_status = "EJECUTADO CORRECTAMENTE";
        invoice_status = "PENDIENTE";
        toast.success("EJECUTADO CORRECTAMENTE", {
          closeButton: true,
        });
      }
      await axios({
        url: url,
        method: "put",
        data: {
          WO_flowID: this.state.WO_Id,
          WO_TaskID: this.state.WO_TaskId,
          params: [
            {
              var: "anulacion_invoice_response",
              value: anulacion_invoice_response,
            },
            {
              var: "anulacion_invoice_status",
              value: anulacion_invoice_status,
            },
            {
              var: "invoice_response",
              value: invoice_response,
            },
            { var: "invoice_status", value: invoice_status },
            { var: "anulacion_invoice_user", value: this.state.invoice_user },
            { var: "numero_factura", value: numero_factura },
          ],
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.token,
        },
      });

      await this.syncReportRealtime("ANULADO");

      this.setState({
        anulacion_invoice_response: anulacion_invoice_response,
        anulacion_invoice_status: anulacion_invoice_status,
        invoice_status: invoice_status,
        numero_factura: numero_factura,
        invoice_response: invoice_response,
      });
      this.setState({ isExecuting: false, modal34: false });
    }
  };

  // Simula en tiempo real lo que dispara el motor cuando esta tarea cierra
  // con la opcion que lleva al conector "actualizaDatosReporteOP"
  // (TASKTYPEID=48 PRIVATECONN en el flujo) -- en vez de esperar a que la
  // tarea cierre de verdad para que el reporte se actualice. Su script hace
  // UPDATE...WHERE ID_PEDIDO=? y solo INSERTa si no existe, asi que llamarlo
  // aca y que el motor lo vuelva a llamar mas tarde al cerrar la tarea no
  // duplica nada, solo re-sincroniza con los datos mas frescos. Se llama
  // DESPUES de guardar los flow vars (el conector los lee de
  // WFP_TMP_FLOWS_VARS via wfpflowid, no del body de este request) y no
  // frena el flujo principal si falla.
  // `estado` es opcional: si se manda, el conector lo usa tal cual en vez
  // de calcularlo el solo (ver override en su script). Sin el parametro se
  // comporta exactamente igual que antes.
  syncReportRealtime = async (estado) => {
    try {
      const data = {
        componentcode: "actualizaDatosReporteOP",
        wfptaskid: this.state.WO_TaskId,
        wfpflowid: this.state.WO_Id,
      };
      if (estado) {
        data.ESTADO = estado;
      }
      await axios({
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.token,
        },
        url: API_CONFIG.xflowurl + "/engine-users/execute-api",
        data: data,
        method: "post",
      });
    } catch (ex) {
      console.log("syncReportRealtime error", ex);
    }
  };

  // HU06 Preventa (subflujo): los items de preventa los pickea la tarea
  // "Picking Preventa" del subflujo flowBolCIPRE. Aca se muestran pero no se
  // pickean ni cuentan para el 100%; la factura sale con la lista completa.
  esPreventa = (sku) =>
    this.state.preventaMap[sku] !== undefined &&
    this.state.preventaMap[sku] !== null;

  cuentaParaProgreso = (o) => o.isValid && !this.esPreventa(o.productSKU);

  // Delivery factura aca, tenga o no preventa: desde el 30/10/2026 la preventa
  // se pickea en "Picking Preventa" ANTES de esta tarea (orden Global ->
  // Preventa -> Individual) y la API de facturacion valida contra SAP, donde la
  // preventa recien existe cuando termina. Hasta que cargue el mapa de preventa
  // no se sabe si hay items de preventa, asi que no se ofrece facturar.
  debeFacturarAqui = () =>
    this.state.tipo_envio === "weight" && this.state.preventaMapLoaded;

  generateInvoice = async (bypass) => {
    if (this.state.locked) return;
    let params = new URLSearchParams(this.props.location.search);
    let officeCode = params.get("officecode");

    let numero_factura, invoice_response, invoice_status, TRX;
    let url = API_CONFIG.xflowurl + "/engine-users/save-flow-field";
    let datos_pedido = "";
    let datos_factura = "";
    let pdf_factura = "";
    //console.log("this", this.state);
    if (bypass) {
      let responseValidation = true;

      if (this.state.numero_factura === "") {
        toast.warning("Debe completar la Factura Manual", {
          closeButton: true,
        });
        responseValidation = false;
        this.setState({
          modal7: true,
        });
      }
      if (responseValidation) {
        this.setState({ isExecuting: true });

        numero_factura = this.state.numero_factura;
        invoice_response = "BYPASS APLICADO";
        invoice_status = "BYPASS";
        TRX = "0";
        //console.log("bypass");

        this.setState({
          invoice_response: invoice_response,
          numero_factura: numero_factura,
          invoice_status: invoice_status,
          TRX: TRX,
        });

        // Misma logica que executeTask() (el metodo que SI cierra la tarea
        // de verdad y ya dispara el conector en produccion, ver mas abajo
        // en este archivo): estos campos solo se tocan cuando
        // tipo_envio==="weight", y ahi monto_real es en realidad
        // monto_total (no this.state.monto_real) y monto_2 va fijo en 0 --
        // asi es como ya funciona hoy, no es una simplificacion mia.
        // fecha_pago solo si metodo_pago==="CONTRAENTREGA". El conector hace
        // _FECHADEPAGO.split("/"), de ahi el formato DD/MM/YYYY.
        const fechaPagoDDMMYYYY = (() => {
          const d = new Date(this.state.from_date);
          const dd = String(d.getDate()).padStart(2, "0");
          const mm = String(d.getMonth() + 1).padStart(2, "0");
          return `${dd}/${mm}/${d.getFullYear()}`;
        })();

        await axios({
          url: url,
          method: "put",
          data: {
            WO_flowID: this.state.WO_Id,
            WO_TaskID: this.state.WO_TaskId,
            params: [
              { var: "razon_social", value: this.state.razon_social },
              ...(this.debeFacturarAqui()
                ? [
                    { var: "metodo_pago", value: this.state.metodo_pago },
                    { var: "monto_real", value: this.state.monto_total },
                    { var: "monto_2", value: 0 },
                    ...(this.state.metodo_pago === "CONTRAENTREGA"
                      ? [{ var: "fecha_pago", value: fechaPagoDDMMYYYY }]
                      : []),
                  ]
                : [{ var: "metodo_pago", value: this.state.metodo_pago }]),
              // Eventos (ya no pasan por "Registrar entrega"): la fecha de pago se fija al facturar,
              // igual que hace externalForm02 con los pedidos normales. Mantis 9012.
              ...(this.state.tipo_envio === "event"
                ? [{ var: "fecha_pago", value: fechaPagoDDMMYYYY }]
                : []),
              { var: "numero_factura", value: numero_factura },
              { var: "invoice_response", value: invoice_response },
              { var: "invoice_status", value: invoice_status },
              { var: "TRX", value: TRX },
              { var: "invoice_user", value: this.state.invoice_user },
              // Momento real de la facturacion, no this.state.from_date: ese estado es
              // el del picker "Fecha de pago", que el cajero puede cambiar, y arrastraba
              // la fecha de factura con el. Con el offset -04:00 declarado, ningun tramo
              // de la cadena lo reinterpreta segun su propia zona.
              { var: "invoice_date", value: instanteBolivia() },
            ],
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.state.token,
          },
        });

        await this.syncReportRealtime("EJECUTADO");

        this.setState({ isExecuting: false, modal33: false });
        toast.success("BYPASS APLICADO", {
          closeButton: true,
        });
      }
    } else {
      let responseValidation = true;

      if (
        this.state.metodo_pago === "TARJETA ATC" ||
        this.state.metodo_pago === "TARJETA LINKSER" ||
        this.state.metodo_pago_2 === "TARJETA ATC" ||
        this.state.metodo_pago_2 === "TARJETA LINKSER"
      ) {
        if (this.state.tarjeta_1.length != 4) {
          responseValidation = false;
          toast.warning("Debe completar los primeros 4 dígitos de la tarjeta", {
            closeButton: true,
          });
        }
        if (this.state.tarjeta_2.length != 4) {
          responseValidation = false;
          toast.warning("Debe completar los últimos 4 dígitos de la tarjeta", {
            closeButton: true,
          });
        }
      }

      if (this.state.razon_social === "") {
        responseValidation = false;
        toast.warning("Debe completar la razón social", { closeButton: true });
      }

      if (this.state.nit === "") {
        responseValidation = false;
        toast.warning("Debe completar la Nit/Carnet de Identidad", {
          closeButton: true,
        });
      }

      if (this.state.tipo_documento === "") {
        responseValidation = false;
        toast.warning("Debe completar el Tipo de Documento", {
          closeButton: true,
        });
      }
      let monto_total = 0;
      if (responseValidation) {
        this.setState({ isExecuting: true });
        let listaProductos = [];
        let id_pedido = this.state.order_id;

        //console.log("orders:", this.state.orders)
        this.state.orders.map((sku, index) => {
          var montoDescuento = 0;

          if (sku.precio || 0 > 0) {
            montoDescuento = sku.precio_lista - sku.precio;
          }

          montoDescuento = Math.round(montoDescuento * 100) / 100;

          var textoRefDescuento = "";

          if (sku.disc_type === "%") {
            textoRefDescuento = "Descuento";
          } else if (sku.disc_type === "COMBO") {
            textoRefDescuento = "Combo";
          } else {
            if (sku.disc_type !== "") {
              textoRefDescuento = sku.type;
            }
          }

          let price = sku.precio > 0 ? sku.precio : sku.precio_lista
          monto_total += (price) * sku.productQty;

          listaProductos.push({
            linea: 1,
            codProducto: sku.productSKU,
            descripcion: sku.productName,
            precioLista: sku.precio_lista,
            precioFinal: price,

            cantidad: sku.productQty,
            codDescuento: "",
            montoDescuento: montoDescuento,
            textoRefDescuento: textoRefDescuento,
            codBodega: this.state.storeCodeI,
            nroPedidoRef: id_pedido,
          });
        });
        monto_total = parseFloat(monto_total.toFixed(2));
        //

        const partes = this.state.razon_social.split(" ");
        const nombres = partes[0];
        const apellidoPat = partes.length > 1 ? partes[1] : "";
        const apellidoMat = partes.length > 2 ? partes.slice(2).join(" ") : "";

        if (this.state.monto_total !== "") {
          console.log("si", this.state.monto_total);

          if (isNaN(this.state.monto_total)) {
            monto_total = parseFloat(
              this.state.monto_total.replace(",", ".")
            ).toFixed(2);
          } else {
            try {
              monto_total = this.state.monto_total.toFixed(2);
            } catch (e) {
              monto_total = this.state.monto_total

            }
            console.log("si", this.state.monto_total);
          }

        }
        const monto_2 = Number(
          parseFloat(this.state.monto_2.replace(",", ".")).toFixed(2)
        );

        let costo_envio = 0;
        console.log("this.state.costo_envio", this.state.costo_envio)
        costo_envio = this.state.costo_envio
        if (isNaN(costo_envio)) {
          if (this.state.costo_envio !== "") {
            costo_envio = Number(
              parseFloat(this.state.costo_envio.replace(",", ".")).toFixed(2)
            );
          }
        } else {
          console.log("ya es numero")
        }
        //console.log("listaProductos", listaProductos);
        //console.log("monto_total", monto_total);
        //console.log("costo_envio", costo_envio);
        let InvoiceData = {
          monto_2: monto_2,
          metodo_pago_2: this.state.metodo_pago_2,
          montoPedido: monto_total,
          officeCode: officeCode,
          componentcode: "facturaXflow",
          id_pedido: id_pedido,
          nit: this.state.nit,
          descuento: this.state.descuento,
          razonSocial: this.state.razon_social,
          nombres: nombres,
          apellidoPat: apellidoPat,
          apellidoMat: apellidoMat,
          email: this.state.email,
          telefono: this.state.telefono.replace("+591 ", ""),
          direccion: this.state.direccion_1,
          referencia: this.state.direccion_2,
          ciudad: this.state.ciudad,
          tarjeta_1: this.state.tarjeta_1,
          tarjeta_2: this.state.tarjeta_2,
          listaProductos: listaProductos,
          storeCodeI: this.state.storeCodeI,
          metodo_pago: this.state.metodo_pago,
          fecha_pago: this.state.from_date,
          codUsuario: this.state.invoice_user,
          cupon_interno: this.state.codigo_cupon,
          costo_envio: costo_envio,
          intento_facturacion: parseInt(this.state.intento_facturacion),
        };
        let response = {};

        await axios({
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.state.token,
          },
          url: API_CONFIG.xflowurl + "/engine-users/execute-api",
          //url : "http://localhost:4042/api/v1"+"/engine-users/execute-api",
          data: InvoiceData,
          method: "post",
        })
          .then((response) => response.data)
          .then((data) => {
            response = data;
          });
        //console.log("response", response);

        if (!response.status) {
          invoice_response = "Error en la facturación";
          invoice_status = "EJECUTADO CON ERROR";
          numero_factura = "-1";
          TRX = "0";
          toast.error(invoice_response, {
            closeButton: true,
          });

          datos_pedido = JSON.stringify(response.data);
          datos_factura = JSON.stringify(response.data2);

          if (!response.resp1.status) {
            //console.log("ERROR API Creacion de pedido", response.resp1);
            invoice_response = response.resp1.data;
            this.setState({
              datos_enviados:
                "....DATOS PEDIDO:..." +
                JSON.stringify(response.data) +
                "....DATOS FACTURA:..." +
                JSON.stringify(response.data2),
            });
            try {
              invoice_response =
                response.resp1.data.ErrorInfoExt.errorMsg +
                ".Código:" +
                response.resp1.data.ErrorInfoExt.errorCode;
            } catch (e) {
              //console.log("error por default");
              invoice_response = response.resp1.message;
            }
          } else {
            if (!response.resp2.status) {
              console.log(
                "Error API Facturacion",
                response.resp2.data.ErrorInfoExt
              );
              this.setState({
                datos_enviados:
                  "....DATOS PEDIDO:..." +
                  JSON.stringify(response.data) +
                  "....DATOS FACTURA:..." +
                  JSON.stringify(response.data2),
              });
              try {
                invoice_response =
                  response.resp2.data.ErrorInfoExt.errorMsg +
                  ".Código:" +
                  response.resp2.data.ErrorInfoExt.errorCode;
              } catch (e) {
                //console.log("error por default");
                invoice_response = response.resp2.message;
              }
            }
          }
        } else {
          //console.log("OK");
          invoice_response = "Factura generada correctamente";
          invoice_status = "EJECUTADO CORRECTAMENTE";

          numero_factura = response.resp2.RespCrearVentaDesdePedidoDatos.numDoc;
          TRX = response.resp2.RespCrearVentaDesdePedidoDatos.nroTrx;
          pdf_factura = response.resp2.RespCrearVentaDesdePedidoDatos.pdfbase64;
          datos_pedido = JSON.stringify(response.data);
          datos_factura = JSON.stringify(response.data2);

          toast.success("EJECUTADO CORRECTAMENTE", {
            closeButton: true,
          });
        }

        // El conector "actualizaDatosReporteOP" espera fecha_pago en
        // DD/MM/YYYY (hace _FECHADEPAGO.split("/") -- ver su scriptbody).
        // this.state.from_date es un Date; mandarlo tal cual llega como ISO
        // por JSON (sin "/") y rompe el parseo, tumbando todo el UPDATE del
        // reporte en silencio.
        const fechaPagoDDMMYYYY = (() => {
          const d = new Date(this.state.from_date);
          const dd = String(d.getDate()).padStart(2, "0");
          const mm = String(d.getMonth() + 1).padStart(2, "0");
          return `${dd}/${mm}/${d.getFullYear()}`;
        })();

        await axios({
          url: url,
          method: "put",
          data: {
            WO_flowID: this.state.WO_Id,
            WO_TaskID: this.state.WO_TaskId,
            params: [
              { var: "numero_factura", value: numero_factura },
              { var: "invoice_response", value: invoice_response },
              { var: "invoice_status", value: invoice_status },
              { var: "TRX", value: TRX },
              { var: "pdf_factura", value: pdf_factura },
              { var: "datos_pedido", value: datos_pedido },
              { var: "datos_factura", value: datos_factura },
              { var: "invoice_user", value: this.state.invoice_user },
              // Momento real de la facturacion, no this.state.from_date: ese estado es
              // el del picker "Fecha de pago", que el cajero puede cambiar, y arrastraba
              // la fecha de factura con el. Con el offset -04:00 declarado, ningun tramo
              // de la cadena lo reinterpreta segun su propia zona.
              { var: "invoice_date", value: instanteBolivia() },
              // Misma logica que executeTask() de este archivo (la que SI
              // cierra la tarea y ya dispara el conector en produccion):
              // solo cuando tipo_envio==="weight" se tocan estos campos, y
              // ahi monto_real es monto_total (no monto_2 real) y monto_2
              // va fijo en 0 -- asi es como ya funciona hoy. fecha_pago
              // solo si metodo_pago==="CONTRAENTREGA".
              ...(this.debeFacturarAqui()
                ? [
                    { var: "metodo_pago", value: this.state.metodo_pago },
                    { var: "monto_real", value: monto_total },
                    { var: "monto_2", value: 0 },
                    ...(this.state.metodo_pago === "CONTRAENTREGA"
                      ? [{ var: "fecha_pago", value: fechaPagoDDMMYYYY }]
                      : []),
                  ]
                : [{ var: "metodo_pago", value: this.state.metodo_pago }]),
              // Eventos: la fecha de pago se fija al facturar (Mantis 9012), ver el bypass.
              ...(this.state.tipo_envio === "event"
                ? [{ var: "fecha_pago", value: fechaPagoDDMMYYYY }]
                : []),
              {
                var: "intento_facturacion",
                value: response.intento_facturacion,
              },
              {
                var: "anulacion_invoice_status",
                value: "",
              },
              {
                var: "anulacion_invoice_response",
                value: "",
              },
            ],
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.state.token,
          },
        });

        this.setState({
          numero_factura: numero_factura,
          invoice_response: invoice_response,
          pdf_factura: pdf_factura,
          invoice_status: invoice_status,
          TRX: TRX,
          intento_facturacion: response.intento_facturacion,
          anulacion_invoice_status: "",
        });

        await this.syncReportRealtime("EJECUTADO");

        this.setState({ isExecuting: false, modal33: false });
      }
    }
  };

  generateInvoiceOld = async (bypass) => {
    if (this.state.locked) return;
    let numero_factura, invoice_response, invoice_status, TRX;
    let url = API_CONFIG.xflowurl + "/engine-users/save-flow-field";

    if (bypass) {
      this.setState({ isExecuting: true });
      TRX = "0";
      numero_factura = "0";
      invoice_response = "BYPASS APLICADO";
      invoice_status = "BYPASS";
      //console.log("bypass");
      this.setState({
        invoice_response: invoice_response,
        numero_factura: numero_factura,
        invoice_status: invoice_status,
      });

      await axios({
        url: url,
        method: "put",
        data: {
          WO_flowID: this.state.WO_Id,
          WO_TaskID: this.state.WO_TaskId,
          params: [
            { var: "numero_factura", value: numero_factura },
            { var: "invoice_response", value: invoice_response },
            { var: "invoice_status", value: invoice_status },
            { var: "TRX", value: TRX },
          ],
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.token,
        },
      });

      this.setState({ isExecuting: false, modal33: false });
      toast.success("BYPASS APLICADO", {
        closeButton: true,
      });
    } else {
      let responseValidation = true;

      if (this.state.razon_social === "") {
        responseValidation = false;
        toast.warning("Debe completar la razon social", { closeButton: true });
      }

      if (this.state.nit === "") {
        responseValidation = false;
        toast.warning("Debe completar la Nit/Carnet de Identidad", {
          closeButton: true,
        });
      }

      if (this.state.tipo_documento === "") {
        responseValidation = false;
        toast.warning("Debe completar el Tipo de Documento", {
          closeButton: true,
        });
      }
      if (responseValidation) {
        this.setState({ isExecuting: true });
        setTimeout(
          async function () {
            if (this.state.nit === "606060") {
              invoice_response = "Error en la facturación(TEST)";
              invoice_status = "EJECUTADO CON ERROR";
              numero_factura = "-1";
              toast.error(invoice_response, {
                closeButton: true,
              });
            } else {
              //console.log("OK");
              invoice_response = "Factura generada correctamente";
              invoice_status = "EJECUTADO CORRECTAMENTE";
              numero_factura =
                Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000;
              toast.success("EJECUTADO CORRECTAMENTE", {
                closeButton: true,
              });
            }
            await axios({
              url: url,
              method: "put",
              data: {
                WO_flowID: this.state.WO_Id,
                WO_TaskID: this.state.WO_TaskId,
                params: [
                  { var: "numero_factura", value: numero_factura },
                  { var: "invoice_response", value: invoice_response },
                  { var: "invoice_status", value: invoice_status },
                  { var: "TRX", value: TRX },
                ],
              },
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + this.state.token,
              },
            });

            this.setState({
              numero_factura: numero_factura,
              invoice_response: invoice_response,
              invoice_status: invoice_status,
            });
            this.setState({ isExecuting: false, modal33: false });
          }.bind(this),
          1500
        );
      }
    }
  };

  changeHandler = (event) => {
    //	//console.log(event.target.id)
    //	//console.log(event.target.value)
    var targetname = event.target.name ? event.target.name : event.target.id;

    if (targetname == "pre_descuento" || targetname == "pre_costo_envio") {
      this.setState({
        ...this.state,
        [targetname]: event.target.value
          .replace(/[^0-9,.]/g, "")
          .replace(/,/g, "."),
      });
    } else {
      this.setState({ ...this.state, [targetname]: event.target.value });
    }
  };

  updateOrdenesyPagos = async (event) => {
    if (this.state.locked) return;
    let _FECHADEPAGO = this.state["fecha_pago"]
      ? this.state["fecha_pago"]
      : null;
    let FECHADEPAGO = null;
    if (_FECHADEPAGO) {
      let _date = _FECHADEPAGO.split("/");
      FECHADEPAGO = new Date(_date[2] + "-" + _date[1] + "-" + _date[0]);
    }

    let Xdata = {
      ID_PEDIDO: this.state.order_id,
      METODO_PAGO: this.state.metodo_pago,
      MONTO: this.state.monto_real || 0,
      METODODEPAGO2: this.state.metododepago2,
      MONTO2: this.state.monto_2 || 0,
      MONTOREAL: this.state.monto_total,
      NROFACTURA: this.state.numero_factura,
      FECHADEPAGO: FECHADEPAGO,
      FECHAINICIO: this.state.fechainicio,
      FECHADEEJECUCION: this.state.fechadeejecucion,
      ESTADO: this.state.estado,
      USUARIO: this.state.username,
      TIPODEENVIO: this.state.tipo_envio_etiqueta,
      AGENCIA: this.state.officecode,
      IDOT: this.state.WO_Id,
      OBSERVACIONES: this.state.observaciones,
      TRX: this.state.TRX,
      POSICION_RACK: this.state.posicion_rack,
      NOTA_SAP: this.state.nota_sap,
      USERNAME: this.state.username,
    };
    //console.log("Xdata:", Xdata, this.state);

    axios({
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.token,
      },
      url: API_CONFIG.xflowurl + "/customcomponents/update/resumen_ordenes",
      data: Xdata,
      method: "put",
    })
      .then((response) => response.data)
      .then((data) => {
        //console.log("response update", data);
      })
      .catch((error) => {
        //console.log("error transaction log execution" + error);
      });
  };

  changePaymentType = async (event) => {
    if (this.state.locked) return;
    //console.log("change",this.state.payId);
    this.setState({ isExecuting: true })
    var tipo_pago = "";
    var tipo_pago_id = "directo";
    //console.log( this.state.payId)

    var payId = this.state.payId;
    this.state.paymentTypes.map(function (s) {
      if (s.value == payId) {
        tipo_pago = s.text;
        if (s.value == 4) {
          tipo_pago_id = "punto_fisico";
        }
      }
    });
    var api_urlV2 = API_CONFIG.casaideasInt;
    let apikey = API_CONFIG.casaideasIntToken;
    var dataDelOrder = {
      orderid: this.state.order_id,
      paymentid: this.state.payId,
      payment: tipo_pago,
      user: this.state.username,
      apikey: apikey,
      action: "updateOrderValues",
      actiontype: "updateOrderPaymentType"
    };
    await axios({
      method: "post",
      headers: { "Content-Type": "application/json", },
      url:
        api_urlV2 +
        "/api/orders/update"
      ,
      data: dataDelOrder, //JSON.stringify(dataDelOrder)
    })
      .then((response) => response.data)
      .then((data) => {
        //console.log(data)
        if (data.status) {
          let url = API_CONFIG.xflowurl + "/engine-users/save-flow-field";
          axios({
            url: url,
            method: "put",
            data: {
              WO_flowID: this.state.WO_Id,
              WO_TaskID: this.state.WO_TaskId,
              params: [
                { var: "pedido_modificado", value: "SI" },
                { var: "tipo_pago", value: tipo_pago },
                { var: "metodo_pago", value: tipo_pago },
                { var: "tipo_pago_id", value: tipo_pago_id },
              ],
            },
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.state.token,
            },
          });

          this.setState({ isExecuting: false, metodo_pago: tipo_pago });
          this.updateOrdenesyPagos();
          toast.success("OK: Procesado Correctamente", {
            closeButton: true,
          });
        } else {
          this.setState({ isExecuting: false });
          toast.error("ERROR:" + data.descResp, {
            closeButton: true,
          });
        }
      });
  };

  changeShippingType = async (event) => {
    if (this.state.locked) return;
    //console.log("change",this.state.shippId);
    this.setState({ isExecuting: true })
    var tipo_envio_etiqueta, tipo_envio_code, tipo_envio;
    //console.log(this.state.shippingTypes)
    tipo_envio_code = this.state.shippId;
    var shippId = this.state.shippId;

    let es_express = "DELETE_es_express";
    this.state.shippingTypes.map(function (s) {
      if (s.value == shippId) {
        tipo_envio_etiqueta = s.text;
        if (s.type == "PICKUP") {
          tipo_envio = "xdelslot";
        } else {
          tipo_envio = "weight";
        }
        if (tipo_envio_etiqueta === "Envío Express") {
          es_express = "SI";
        }
      }
    });

    var api_urlV2 = API_CONFIG.casaideasInt;
    let apikey = API_CONFIG.casaideasIntToken;
    var dataDelOrder = {
      orderid: this.state.order_id,
      shippingid: this.state.shippId,
      shipping: tipo_envio_etiqueta,
      user: this.state.username,
      apikey: apikey,
      action: "updateOrderValues",
      actiontype: "updateOrderShippingType"
    };
    await axios({
      method: "post",
      headers: { "Content-Type": "application/json", },
      url:
        api_urlV2 +
        "/api/orders/update"
      ,
      data: dataDelOrder, //JSON.stringify(dataDelOrder)
    })
      .then((response) => response.data)
      .then((data) => {
        //console.log(data)
        if (data.status) {
          let url = API_CONFIG.xflowurl + "/engine-users/save-flow-field";
          //let url = "http://localhost:4042/api/v1"+"/engine-users/save-flow-field";

          axios({
            url: url,
            method: "put",
            data: {
              WO_flowID: this.state.WO_Id,
              WO_TaskID: this.state.WO_TaskId,
              params: [
                { var: "pedido_modificado", value: "SI" },
                { var: "es_express", value: es_express },

                { var: "tipo_envio", value: tipo_envio },
                { var: "tipo_envio_code", value: tipo_envio_code },
                { var: "tipo_envio_etiqueta", value: tipo_envio_etiqueta },
              ],
            },
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.state.token,
            },
          });

          this.setState({
            isExecuting: false,
            tipo_envio: tipo_envio,
            tipo_envio_etiqueta: tipo_envio_etiqueta,
          });

          this.updateOrdenesyPagos();

          toast.success("OK: Procesado Correctamente", {
            closeButton: true,
          });
        } else {
          this.setState({ isExecuting: false });
          toast.error("ERROR:" + data.descResp, {
            closeButton: true,
          });
        }
      });
  };

  changeShippingCost = async (event) => {
    if (this.state.locked) return;
    //console.log("change",this.state.pre_costo_envio);
    this.setState({ isExecuting: true })
    var api_urlV2 = API_CONFIG.casaideasInt;
    let apikey = API_CONFIG.casaideasIntToken;
    var dataDelOrder = {
      orderid: this.state.order_id,
      shippingcost: this.state.pre_costo_envio,
      user: this.state.username,
      apikey: apikey,
      action: "updateOrderValues",
      actiontype: "updateOrderShippingCost"
    };
    await axios({
      method: "post",
      headers: { "Content-Type": "application/json", },
      url:
        api_urlV2 +
        "/api/orders/update"
      ,
      data: dataDelOrder, //JSON.stringify(dataDelOrder)
    })
      .then((response) => response.data)
      .then((data) => {
        //console.log(data)
        if (data.status) {
          let monto_total = data.total;
          let sub_total = data.subtotal;
          let descuento = data.descuento;

          this.setState({
            ...this.state,
            descuento: descuento,
            pre_descuento: descuento,
            monto_total: monto_total,
            costo_envio: this.state.pre_costo_envio,
            sub_total: parseFloat(sub_total, 2).toFixed(2),
          });

          let url = API_CONFIG.xflowurl + "/engine-users/save-flow-field";
          //let url = "http://localhost:4042/api/v1"+"/engine-users/save-flow-field";

          axios({
            url: url,
            method: "put",
            data: {
              WO_flowID: this.state.WO_Id,
              WO_TaskID: this.state.WO_TaskId,
              params: [
                { var: "pedido_modificado", value: "SI" },
                { var: "monto_total", value: monto_total },
                {
                  var: "shipping_cost",
                  value: parseFloat(this.state.pre_costo_envio, 2).toFixed(2),
                },
              ],
            },
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.state.token,
            },
          });
          this.updateOrdenesyPagos();
          this.setState({ isExecuting: false });

          toast.success("OK: Procesado Correctamente", {
            closeButton: true,
          });
        } else {
          this.setState({ isExecuting: false });
          toast.error("ERROR:" + data.descResp, {
            closeButton: true,
          });
        }
      });
  };

  //DEPRECADO
  changeDiscount = async (event) => {
    //console.log("change",this.state.pre_descuento);
    /*
    var dataDelOrder = {
      order_id: this.state.order_id,
      discount: this.state.pre_descuento,
      user: this.state.username,
    };

    await axios({
      method: "post",
      // headers: {  'Access-Control-Allow-Origin':'*' },

      url:
        this.state.store_url +
        "externalapi/execute/editDiscountOrder/key/" +
        OP_SECRET_KEY,
      data: dataDelOrder, //JSON.stringify(dataDelOrder)
    })
      .then((response) => response.data)
      .then((data) => {
        //console.log(data)
        if (data.status) {
          let oldOrders = this.state.orders;
          let monto_total = 0;
          let sub_total = 0;
          for (var key in this.state.orders) {
            let obj = this.state.orders[key];
            let productPrice = oldOrders[key].precio > 0 ? oldOrders[key].precio : oldOrders[key].precio_lista;
            let productQty = oldOrders[key].productQty;
            let total = productQty * productPrice;
            monto_total = monto_total + total;
            sub_total = sub_total + total;
          }
          monto_total = (
            parseFloat(monto_total) +
            parseFloat(this.state.costo_envio) -
            parseFloat(this.state.pre_descuento)
          ).toFixed(2);
          this.setState({
            ...this.state,
            monto_total: monto_total,
            descuento: this.state.pre_descuento,
            sub_total: parseFloat(sub_total, 2).toFixed(2),
          });

          let url = API_CONFIG.xflowurl + "/engine-users/save-flow-field";
          //let url = "http://localhost:4042/api/v1"+"/engine-users/save-flow-field";

          axios({
            url: url,
            method: "put",
            data: {
              WO_flowID: this.state.WO_Id,
              WO_TaskID: this.state.WO_TaskId,
              params: [
                { var: "pedido_modificado", value: "SI" },
                { var: "monto_total", value: monto_total },
                {
                  var: "discount",
                  value: parseFloat(this.state.pre_descuento, 2).toFixed(2),
                },
              ],
            },
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.state.token,
            },
          });
          this.updateOrdenesyPagos();
          this.setState({ isExecuting: false });

          toast.success("OK: Procesado Correctamente", {
            closeButton: true,
          });
        } else {
          this.setState({ isExecuting: false });
          toast.error("ERROR:" + data.descResp, {
            closeButton: true,
          });
        }
      });
    */
  };

  handleChangePrice = (event) => {
    //console.log(event.target.name)
    //console.log(event.target.value)

    let oldOrders = this.state.orders;

    let data = event.target.name.split("_")
    //	//console.log(oldOrders)
    let type = data[0]
    let name = data[1]

    //console.log("name", name, type)
    for (var key in oldOrders) {
      let obj = oldOrders[key];

      if (Number(oldOrders[key].id) === Number(name)) {
        //obj["state"]= "deleting"
        //console.log(oldOrders[key])
        if (type === "SKUPRICE") {
          oldOrders[key].precio_lista = event.target.value
            .replace(/[^0-9,.]/g, "")
            .replace(/,/g, ".");
        } else {
          oldOrders[key].precio = event.target.value
            .replace(/[^0-9,.]/g, "")
            .replace(/,/g, ".");
        }
      }
    }

    this.setState({
      ...this.state,
      orders: oldOrders,
    });
  };

  handleCommitPrice = async (eventId, type) => {
    if (this.state.locked) return;
    let neworders = [];
    let product_id;
    let productQty = 0;
    let productPrice;
    let productSKU;
    let precio_lista;
    let precio = 0;
    let oldOrders = this.state.orders;
    //console.log("eventId", eventId)
    for (var key in oldOrders) {
      let obj = oldOrders[key];

      if (oldOrders[key].id === eventId) {
        //obj["state"]= "deleting"
        //console.log(oldOrders[key])
        product_id = oldOrders[key].product_id;
        productQty = parseInt(oldOrders[key].productQty);
        productSKU = oldOrders[key].productSKU;
        productPrice = oldOrders[key].productPrice;
        precio_lista = Number(oldOrders[key].precio_lista)
        if (oldOrders[key].precio && oldOrders[key].precio !== "") {
          precio = Number(oldOrders[key].precio)
        }
        //obj["productQty"]=  type==="Add"? productQty+1:productQty-1
      }
      neworders.push(obj);
    }
    this.setState({ isExecuting: true });
    var api_urlV2 = API_CONFIG.casaideasInt;
    let apikey = API_CONFIG.casaideasIntToken;

    var dataDelOrder = {
      id: eventId,
      orderid: this.state.order_id,
      user: this.state.username,
      precio_regular: precio_lista,
      precio: precio ?? 0,
      apikey: apikey,
      sku: productSKU,
      action: "updateOrderProductPrice"
    };
    await axios({
      method: "post",
      headers: { "Content-Type": "application/json", },
      url:
        api_urlV2 +
        "/api/orders/update"
      ,
      data: dataDelOrder, //JSON.stringify(dataDelOrder)
    })
      .then((response) => response.data)
      .then((data) => {
        if (data.status) {
          console.log("data", data)
          let monto_total = data.total;
          let sub_total = data.subtotal;
          let descuento = data.descuento;

          this.setState({
            ...this.state,
            descuento: descuento,
            pre_descuento: descuento,
            monto_total: monto_total,
            sub_total: parseFloat(sub_total, 2).toFixed(2),
          });

          let url = API_CONFIG.xflowurl + "/engine-users/save-flow-field";
          //let url = "http://localhost:4042/api/v1"+"/engine-users/save-flow-field";
          axios({
            url: url,
            method: "put",
            data: {
              WO_flowID: this.state.WO_Id,
              WO_TaskID: this.state.WO_TaskId,
              params: [
                { var: "pedido_modificado", value: "SI" },
                { var: "monto_total", value: monto_total },
                { var: "subtotal", value: parseFloat(sub_total, 2).toFixed(2) },
              ],
            },
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.state.token,
            },
          });

          this.updateOrdenesyPagos();
          this.setState({ isExecuting: false });
          //this.setState({ orders:neworders });
          //console.log(this.state.orders);
          toast.success("OK: Procesado Correctamente", {
            closeButton: true,
          });
        } else {
          for (var key in this.state.orders) {
            let obj = this.state.orders[key];

            if (this.state.orders[key].id === eventId) {
              obj["state"] = "error";
              //console.log ("set err")
            }
            neworders.push(obj);
          }
          this.setState({ orders: neworders, isExecuting: false });
          toast.error("ERROR:" + data.descResp, {
            closeButton: true,
          });
        }
      });
  };

  changeHandlerSKU = async (event) => {
    console.log(event.target.name, event.target.value, this.state.orders)
    let value = event.target.value;
    this.setState({ read_sku: value });
    let validSKU = false;
    if (value.length >= 12) {
      for (var key in this.state.orders) {
        if (this.state.orders[key].productSKU == value) {
          let obj = this.state.orders[key];
          console.log("este es", obj, key)
          let qty = 1;

          if (obj["qtyPicked"]) {
            qty = obj["qtyPicked"] + 1;
          }

          if (qty <= obj.productQty) {
            await this.handlePick(obj.id, qty);

            this.setState({ read_sku: "" });
            toast.success("OK:" + "Lectura del sku:" + value + " correcta", {
              closeButton: true,
            });
          } else {
            this.setState({ read_sku: "" });
            toast.error("NOK:" + "Cantidad del SKU" + value + " superada", {
              closeButton: true,
            });
          }
          validSKU = true;
        }
      }

      if (!validSKU) {
        toast.error("NOK:" + "SKU: " + value + " no encontrado", {
          closeButton: true,
        });
      }
    }
  };

  handleBarcodeDetected = (value) => {
    this.changeHandlerSKU({
      target: {
        name: "read_sku",
        value: value.trim(),
      },
    });
  };

  handlePick = async (producto, qty) => {
    if (this.state.locked) return;

    // HU06 Preventa -- gate real, igual que en externalForm04.js "Picking
    // Global". El gate visual del badge (Event, mas arriba) no alcanza
    // solo: "Leer SKU"/handleBarcodeDetected llama a handlePick directo,
    // sin pasar por el onClick del badge -- confirmado en vivo que un SKU
    // de preventa escaneado por codigo de barras se pickeaba igual aunque
    // el badge ya mostrara rojo.
    if (!this.state.preventaMapLoaded) {
      toast.warning(
        "Cargando informacion de preventa, espera un momento e intenta de nuevo.",
        { closeButton: true }
      );
      return;
    }
    const objetivo = this.state.orders.find((o) => o.id === producto);
    if (objetivo && this.esPreventa(objetivo.productSKU)) {
      toast.warning(
        `"${objetivo.productName}" es de preventa: se pickea en la tarea "Picking Preventa".`,
        { closeButton: true }
      );
      return;
    }

    console.log(producto, this.state.orders)
    let neworders = [];
    let product_ids = "";
    let totalProd = 0;
    let totalPicked = 0;

    this.setState({ isExecuting: true });
    for (var key in this.state.orders) {
      let obj = this.state.orders[key];
      //console.log(this.state.orders[key])

      if (this.state.orders[key].id == producto) {
        if (qty) {
          console.log("op 1")
          obj["qtyPicked"] = qty;
          if (qty === this.state.orders[key].productQty) {
            obj["isPicked"] = 1;
          } else {
            obj["isPicked"] = -1;
          }
        } else {
          console.log("op 2")
          obj["qtyPicked"] =
            this.state.orders[key].isPicked === -1
              ? this.state.orders[key].productQty
              : 0;
          obj["isPicked"] = this.state.orders[key].isPicked === -1 ? 1 : -1;
        }
        //obj["qtyPicked"]= this.state.orders[key].isPicked===-1?1:-1;
      }
      neworders.push(obj);
    }

    for (var key in neworders) {
      //console.log(neworders[key]);
      if (this.cuentaParaProgreso(neworders[key])) {
        totalProd++;
      }
      if (neworders[key].qtyPicked > 0) {
        product_ids =
          product_ids +
          "|" +
          neworders[key].product_id +
          "," +
          neworders[key].qtyPicked +
          "," +
          neworders[key].productQty;
      }

      if (this.cuentaParaProgreso(neworders[key]) && neworders[key].isPicked > 0) {
        totalPicked++;
      }
    }
    if (product_ids.length > 1) {
      product_ids = product_ids.substr(1, product_ids.length);
    }

    let progress_i =
      totalProd === 0 ? 100 : Math.ceil((totalPicked / totalProd) * 100);
    //console.log("progress_i", progress_i, totalProd);
    let url = API_CONFIG.xflowurl + "/engine-users/save-flow-field";
    //let url = "http://localhost:4042/api/v1"+"/engine-users/save-flow-field";

    await axios({
      url: url,
      method: "put",
      data: {
        WO_flowID: this.state.WO_Id,
        WO_TaskID: this.state.WO_TaskId,
        params: [
          { var: "picking_products_i", value: product_ids },
          { var: "progress_i", value: progress_i },
          //{ var :"pedido_completo2", value : progress_i},
        ],
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.token,
      },
    })
      .then((response) => response.data)
      .then((data) => {
        this.setState({ isExecuting: false });
      });

    this.setState({ orders: neworders, progress_i: progress_i });
  };
  //DEPRECATED
  deleteShipping = async (eventId) => {
    if (this.state.locked) return;
    let url = API_CONFIG.base_url + "/externalApi/testRestApi/";
    this.setState({ isExecuting: true });
    await axios
      .post(url, { params: 1 })
      .then((response) => response.data)
      .then((data) => {
        //console.log(data);
        if (data.resp === "OK") {
          this.setState({ isDeleted: true });
          toast.success(
            "OK:" + "Se elimino el cobro de envio del pedido:" + eventId,
            {
              closeButton: true,
            }
          );
        }
        this.setState({ isExecuting: false });
      });
  };

  updateOtherOrder = async (eventId) => {
    if (this.state.locked) return;
    if (this.state.pedido_parcial === "SI") {
      let url = API_CONFIG.xflowurl + "/engine-users/get-var-by-flow";
      axios({
        url: url,
        method: "post",
        data: {
          varname: "order_id",
          varvalue: this.state.order_id,
          flowcode:
            this.state.flowcode === "flowBolCI07"
              ? "flowBolCI01"
              : "flowBolCI07",
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.token,
        },
      })
        .then((response) => response.data)
        .then((data) => {
          if (data.result.length === 1) {
            let url = API_CONFIG.xflowurl + "/engine-users/save-flow-field";
            axios({
              url: url,
              method: "put",
              data: {
                WO_flowID: data.result[0].WFPFLOWID,
                WO_TaskID: -10,
                params: [
                  { var: "skus", value: JSON.stringify(this.state.skus) },
                  {
                    var: "mixed_skus",
                    value: JSON.stringify(this.state.mixed_skus),
                  },
                ],
              },
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + this.state.token,
              },
            })
              .then((response) => response.data)
              .then((data) => {
                //console.log("res:", data);
              });
          }
        });
    }
  };

  setProduct = async (event) => {
    var id = event.target.id.substr(5, 10);
    this.setState({
      ...this.state,
      product_id: this.state.searchResults[id].product_id,
      productName: this.state.searchResults[id].name,
      productImageBig: this.state.searchResults[id].productImage,
      productPrice: parseFloat(this.state.searchResults[id].price),
      productImage: this.state.searchResults[id].thumb,
      productModel: this.state.searchResults[id].productModel,
      productSKU: this.state.searchResults[id].productSKU,
      productQty: 1,
      productMaxQty: this.state.searchResults[id].quantity,
      productStocks: this.state.searchResults[id].stocks || [],
      isExecuting: false,
      showProductsList: false,
      disabledAdd: false,
    });
    //console.log("this", this.state);
  };

  // Disponibilidad solo de las tiendas relevantes: home = officecode actual, online = officecodeONLINE (flowBolCI07)
  getStockByStore = () => {
    const stocks = this.state.productStocks || [];
    const homeCode = normalizeOfficeCode(this.state.officecode);
    const onlineCode = normalizeOfficeCode(this.state.officecodeONLINE);

    return stocks
      .map((s) => {
        const code = normalizeOfficeCode(s.warehouse_code);
        const available = Number(s.quantity || 0) - Number(s.reserved_quantity || 0);
        let variant = null;
        if (code === homeCode) variant = "home";
        else if (onlineCode && code === onlineCode) variant = "online";
        return { code, available, variant };
      })
      .filter((s) => s.variant !== null);
  };

  searchProduct = async () => {
    this.setState({
      showProductsList: true,
      isExecuting: true,
      searchResults: [],
      disabledAdd: true,
    });

    var api_urlV2 = API_CONFIG.casaideasInt;
    let apikey = API_CONFIG.casaideasIntToken;
    var data = {
      sku: this.state.SKUcode,
      apikey: apikey
    };
    await axios({
      method: "post",
      headers: { "Content-Type": "application/json", },
      url:
        api_urlV2 +
        "/api/products/search"
      ,
      data: data, //JSON.stringify(dataDelOrder)
    })

      .then((response) => response.data)
      .then((data) => {
        if (data.status) {
          var results = [];

          for (var i = 0; i < data.result.length; i++) {
            results.push({
              id: i,
              key: "key" + data.result[i].id,
              product_id: data.result[i].id,
              // Mantis 9081: el nombre de la variante (specific_name) tiene prioridad
              // sobre el nombre por defecto del producto.
              name: (data.result[i].specific_name || "").trim() || data.result[i].name,
              quantity: 10,
              thumb: this.state.imagePath + data.result[i].images_path + data.result[i].sku + "_1_mini.jpg",
              productSKU:
                data.result[i].sku === undefined
                  ? "-"
                  : data.result[i].sku,
              productModel:
                data.result[i].sku === undefined
                  ? "-"
                  : data.result[i].sku,
              productImage: this.state.imagePath + data.result[i].images_path + data.result[i].sku + "_1.jpg",
              price: parseFloat(data.result[i].price),
              precio_lista: parseFloat(data.result[i].price),
              precio: null,
              special: null,
              stocks: data.result[i].stocks || [],
              selected: (
                <>
                  <span
                    key={"table_" + i}
                    id={"table_" + i}
                    onClick={this.setProduct}
                    className="tableLink"
                  >
                    <MDBIcon
                      icon="check-circle"
                      key={"icon_" + i}
                      id={"icon_" + i}
                      size="2x"
                      style={{ cursor: "pointer" }}
                      className="green-text"
                    />
                  </span>
                </>
              ),
            });
          }

          //console.log("results", results)
          this.setState({
            ...this.state,
            searchResults: results,
            isExecuting: false,
          });
          //console.log(this.state.searchResults)
        } else {
          this.setState({
            ...this.state,
            product_id: 0,
            productName: "NO DATA",
            productPrice: 0,
            productQty: 10,
            productMaxQty: 0,
            isExecuting: false,
            disabledAdd: true,
          });
        }
      });
  };
  /*CHECK HERE*/
  addOrder = async () => {
    if (this.state.locked) return;
    let newOrders = this.state.orders;
    let newId = newOrders.length + 1;

    const skus = this.state.skus;
    const mixed_skus = this.state.mixed_skus;

    var api_urlV2 = API_CONFIG.casaideasInt;
    let apikey = API_CONFIG.casaideasIntToken;
    const isPickup =
      this.state.taskName === "Seguimiento de Pedidos" &&
      this.state.flowcode === "flowBolCI07";

    let dataNewOrder = {
      orderid: this.state.order_id,
      productid: this.state.product_id,
      productname: this.state.productName,
      sku: this.state.productSKU,
      price: this.state.productPrice,
      image: this.state.productImageBig.replace(this.state.imagePath, ""),
      user: this.state.username,
      quantity: Array.isArray(this.state.productQty)
        ? this.state.productQty[0]
        : this.state.productQty,
      apikey: apikey,
      isPickup: isPickup,
      action: "addOrderProduct"
    };
    //console.log("dataNewOrder", dataNewOrder, this.state);

    this.setState({ isExecuting: true });

    await axios({
      method: "post",
      headers: { "Content-Type": "application/json", },
      url:
        api_urlV2 +
        "/api/orders/update"
      ,
      data: dataNewOrder, //JSON.stringify(dataDelOrder)
    })
      .then((response) => response.data)
      .then((data) => {
        //console.log(data);
        if (data.status) {
          //	//console.log(this.props.match.params.WO_Id);
          newId = data.id
          //console.log(newId);

          newOrders.push({
            id: newId,
            product_id: this.state.product_id,
            productName: this.state.productName,
            //productPrice:this.state.productPrice,
            //productQty:this.state.productQty,
            productPrice: parseFloat(this.state.productPrice).toFixed(2),
            precio_lista: parseFloat(this.state.productPrice).toFixed(2),
            precio: null,
            productQty: Array.isArray(this.state.productQty)
              ? this.state.productQty[0]
              : this.state.productQty,
            productSKU: this.state.productSKU,
            isPicked: -1,
            isValid: true,
            productModel: this.state.productModel,
            productImage: this.state.productImage,
            state: "loaded",
          });

          let storeCode = this.state.officecode;

          skus.push({
            NAME: this.state.productSKU,
            VALUE: Array.isArray(this.state.productQty)
              ? this.state.productQty[0]
              : this.state.productQty,
          });
          mixed_skus.push({
            store: storeCode,
            sku: this.state.productSKU,
            qty: Array.isArray(this.state.productQty)
              ? this.state.productQty[0]
              : this.state.productQty,
          });

          //console.log("storeCode", storeCode);

          //console.log("skus", skus);
          //console.log("mixed_skus", mixed_skus);

          let monto_total = data.total;
          let sub_total = data.subtotal;
          let descuento = data.descuento;
          var totalProd = 0;
          var totalPicked = 0;
          var product_ids = "";
          for (var key in newOrders) {
            if (this.esPreventa(newOrders[key].productSKU)) continue;
            totalProd++;
            if (newOrders[key].isPicked > 0) {
              product_ids =
                product_ids +
                "|" +
                newOrders[key].product_id +
                "," +
                newOrders[key].productQty +
                "," +
                newOrders[key].productQty;
              totalPicked++;
            }
          }

          if (product_ids.length > 1) {
            product_ids = product_ids.substr(1, product_ids.length);
          }
          let progress_i =
            totalProd === 0 ? 100 : Math.ceil((totalPicked / totalProd) * 100);

          this.setState({
            ...this.state,
            descuento: descuento,
            pre_descuento: descuento,
            monto_total: monto_total,
            mixed_skus: mixed_skus,
            skus: skus,
            sub_total: parseFloat(sub_total, 2).toFixed(2),
          });
          let url = API_CONFIG.xflowurl + "/engine-users/save-flow-field";
          axios({
            url: url,
            method: "put",
            data: {
              WO_flowID: this.state.WO_Id,
              WO_TaskID: this.state.WO_TaskId,
              params: [
                { var: "pedido_modificado", value: "SI" },
                { var: "monto_total", value: monto_total },
                { var: "picking_products_i", value: product_ids },
                { var: "progress_i", value: progress_i },
                { var: "subtotal", value: parseFloat(sub_total, 2).toFixed(2) },
                { var: "skus", value: JSON.stringify(skus) },
                { var: "mixed_skus", value: JSON.stringify(mixed_skus) },
              ],
            },
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.state.token,
            },
          });
          //CHECK!!!
          /*
          url = API_CONFIG.base_url + "/externalApi/updateProductsByOrderID/";
          axios({
            url: url,
            method: "post",
            data: {
              flowId: this.props.match.params.WO_Id,
              order_id: this.state.order_id,
              SKU: this.state.productSKU,
              quantity: Array.isArray(this.state.productQty)
                ? this.state.productQty[0]
                : this.state.productQty,
              org: this.state.org,
            },
            headers: { apikey: "xflow1506103c404d6dccaf787e44cf123456789" },
          });
          */

          toast.success("OK: Procesado Correctamente", {
            closeButton: true,
          });
          this.updateOrdenesyPagos();
        } else {
          toast.error("ERROR:" + data.descResp, {
            closeButton: true,
          });
        }
        //console.log("New newOrders", newOrders)
        this.setState({ isExecuting: false, orders: newOrders, modal3: false });
      });

    this.updateOtherOrder();
  };

  handleDelete = (producto) => {
    this.setState({
      accion: "eliminar",
      modal5: true,
      mensaje: "Eliminar este producto?",
      id_producto: producto,
    });
  };

  handleDeleteOtherFlow = async (store) => {
    if (this.state.locked) return;
    this.setState({ isExecuting: true });
    const saveUrl = API_CONFIG.xflowurl + "/engine-users/save-flow-field";
    const currentWarning = this.state.crossStoreWarning;
    let apiResult = null;

    // Tienda distinta al office: dejar pendiente hasta definir logica
    if (store !== this.state.officecode) {
      const _pending = {
        stores: currentWarning ? currentWarning.stores : [store],
        status: "pending",
        result: null,
      };
      await axios({
        url: saveUrl,
        method: "put",
        data: {
          WO_flowID: this.state.WO_Id,
          WO_TaskID: this.state.WO_TaskId,
          params: [{ var: "pending_crossstore_delete", value: JSON.stringify(_pending) }],
        },
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + this.state.token },
      });
      toast.info("Tienda " + store + " distinta al office: borrado pendiente", { closeButton: true });
      this.setState({ isExecuting: false });
      return;
    }

    const commentary = `Eliminado por ${this.state.username} desde el flujo ${this.state.WO_flowID}`
    try {
      const resp = await axios({
        method: "put",
        url: API_CONFIG.xflowurl + "/engine-users/kill-flow-by-var",
        data: { varname: this.state.orderName, varvalue: this.state.order_id, flowid: this.state.flowid, officecode: store, commentary },
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + this.state.token },
      });
      apiResult = resp.data;
    } catch (err) {
      toast.error("Error al eliminar flujo de " + store);
      this.setState({ isExecuting: false });
      return;
    }

    const _success = apiResult && apiResult.status === true;
    const _msg = apiResult && (apiResult.message_es || apiResult.message);
    if (_success) {
      toast.success(_msg || ("Flujo de " + store + " eliminado"));
    } else {
      toast.warn(_msg || ("No se pudo eliminar flujo de " + store));
    }

    if (_success) {
      const _record = {
        stores: currentWarning ? currentWarning.stores : [store],
        status: "completed",
        result: apiResult,
      };
      await axios({
        url: saveUrl,
        method: "put",
        data: {
          WO_flowID: this.state.WO_Id,
          WO_TaskID: this.state.WO_TaskId,
          params: [{ var: "pending_crossstore_delete", value: JSON.stringify(_record) }],
        },
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + this.state.token },
      });
      this.setState({ crossStoreWarning: null });
    }

    this.setState({ isExecuting: false });
  };
  getDeleteWarningStores = () => {
    const deletedProduct = this.state.orders.find(
      (o) => o.id === this.state.id_producto
    );
    if (!deletedProduct || !this.state.mixed_skus || !this.state.mixed_skus.length)
      return [];
    const sku = deletedProduct.productSKU.toString();
    const affectedStores = [
      ...new Set(
        this.state.mixed_skus
          .filter((m) => m.sku && m.sku.toString() === sku)
          .map((m) => m.store)
      ),
    ];
    if (!affectedStores.length) return [];
    const remaining = this.state.mixed_skus.filter(
      (m) => !m.sku || m.sku.toString() !== sku
    );
    return affectedStores.filter(
      (store) => !remaining.some((m) => m.store === store)
    );
  };

  handlePrice = (producto) => {
    //console.log(producto)
    this.setState({
      accion: "cambiar",
      modal5: true,
      mensaje: "Cambiar el precio al producto?",
      id_producto: producto,
    });
  };

  handleEdit = (producto, type) => {
    this.handleCommitEdit(producto, type === "aumentar" ? "Add" : "Rem");
  };

  /*CHECK HERE*/
  handleCommitEdit = async (eventId, type) => {
    if (this.state.locked) return;
    //console.log("edit"+eventId+"type:"+type);

    let neworders = [];
    let product_id;
    let productQty = 0;
    let productSKU;
    let oldOrders = this.state.orders;
    let newSkus = [];
    const mixed_skus = this.state.mixed_skus;
    for (var key in oldOrders) {
      let obj = oldOrders[key];

      if (oldOrders[key].id === eventId) {
        //obj["state"]= "deleting"
        console.log(oldOrders[key])
        product_id = oldOrders[key].product_id;
        productQty = parseInt(oldOrders[key].productQty);
        productSKU = oldOrders[key].productSKU;

        obj["productQty"] = type === "Add" ? productQty + 1 : productQty - 1;
      }
      neworders.push(obj);

      //NUEVA LOGICA POR PICKUP

      let pos = mixed_skus.findIndex(
        (item) => item.sku.toString() === oldOrders[key].productSKU.toString()
      );
      //console.log("pos", pos);
      if (pos >= 0) {
        //console.log("es!!!!", mixed_skus[pos]);
        mixed_skus[pos]["qty"] = obj["productQty"];
        this.setState({ mixed_skus: mixed_skus });
      }
      newSkus.push({ NAME: oldOrders[key].productSKU, VALUE: obj["productQty"] });

      //NUEVA LOGICA POR PICKUP
    }
    var api_urlV2 = API_CONFIG.casaideasInt;
    let apikey = API_CONFIG.casaideasIntToken;
    const isPickup =
      this.state.taskName === "Seguimiento de Pedidos" &&
      this.state.flowcode === "flowBolCI07";
    var dataDelOrder = {
      id: eventId,
      orderid: this.state.order_id,
      user: this.state.username,
      quantity: type === "Add" ? productQty + 1 : productQty - 1,
      apikey: apikey,
      sku: productSKU,
      isPickup: isPickup,
      action: "updateOrderProductQty"
    };

    this.setState({ isExecuting: true });
    /*  
      //console.log("dataDelOrder", dataDelOrder);
      //console.log("skus", this.state);
      //console.log("nwe skus", JSON.stringify(newSkus));
      //console.log("new mixed_skus", JSON.stringify(mixed_skus));
  */

    await axios({
      method: "post",
      headers: { "Content-Type": "application/json", },
      url:
        api_urlV2 +
        "/api/orders/update"
      ,
      data: dataDelOrder, //JSON.stringify(dataDelOrder)
    })
      .then((response) => response.data)
      .then((data) => {
        if (data.status) {
          let monto_total = data.total;
          let sub_total = data.subtotal;
          let descuento = data.descuento;
          this.setState({
            ...this.state,
            descuento: descuento,
            pre_descuento: descuento,
            monto_total: monto_total,
            sub_total: parseFloat(sub_total, 2).toFixed(2),
          });
          let url = API_CONFIG.xflowurl + "/engine-users/save-flow-field";
          //let url = "http://localhost:4042/api/v1"+"/engine-users/save-flow-field";

          axios({
            url: url,
            method: "put",
            data: {
              WO_flowID: this.state.WO_Id,
              WO_TaskID: this.state.WO_TaskId,
              params: [
                { var: "pedido_modificado", value: "SI" },
                { var: "monto_total", value: monto_total },
                { var: "subtotal", value: parseFloat(sub_total, 2).toFixed(2) },
                { var: "skus", value: JSON.stringify(newSkus) },
                { var: "mixed_skus", value: JSON.stringify(mixed_skus) },
              ],
            },
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.state.token,
            },
          });
          /*
          url = API_CONFIG.base_url + "/externalApi/updateProductsByOrderID/";
          axios({
            url: url,
            method: "post",
            data: {
              flowId: this.props.match.params.WO_Id,
              order_id: this.state.order_id,
              SKU: productSKU,
              quantity: type === "Add" ? productQty + 1 : productQty - 1,
              org: this.state.org,
            },
            headers: { apikey: "xflow1506103c404d6dccaf787e44cf123456789" },
          });
          */
          this.updateOrdenesyPagos();
          this.setState({ isExecuting: false });
          //this.setState({ orders:neworders });
          //console.log(this.state.orders);
          toast.success("OK: Procesado Correctamente", {
            closeButton: true,
          });
        } else {
          for (var key in this.state.orders) {
            let obj = this.state.orders[key];

            if (this.state.orders[key].id === eventId) {
              obj["state"] = "error";
              //console.log ("set err")
            }
            neworders.push(obj);
          }
          this.setState({ orders: neworders, isExecuting: false });
          toast.error("ERROR:" + data.descResp, {
            closeButton: true,
          });
        }
      });
    this.updateOtherOrder();
  };
  /*CHECK HERE*/
  handleCommitDelete = async (eventId) => {
    if (this.state.locked) return;
    //console.log("del" + eventId);
    let neworders = [];
    let product_id;
    let productQty;
    let productSKU;
    let skus = this.state.skus;
    let mixed_skus = this.state.mixed_skus;
    for (var key in this.state.orders) {
      let obj = this.state.orders[key];
      //console.log(obj);
      if (this.state.orders[key].id === eventId) {
        obj["state"] = "deleting";
        product_id = this.state.orders[key].product_id;
        productQty = this.state.orders[key].productQty;
        productSKU = this.state.orders[key].productSKU;
      }
      neworders.push(obj);
    }
    var api_urlV2 = API_CONFIG.casaideasInt;
    let apikey = API_CONFIG.casaideasIntToken;
    const isPickup =
      this.state.taskName === "Seguimiento de Pedidos" &&
      this.state.flowcode === "flowBolCI07";
    var dataDelOrder = {
      id: eventId,
      orderid: this.state.order_id,
      user: this.state.username,
      quantity: 0,
      sku: productSKU,
      apikey: apikey,
      isPickup: isPickup,
      action: "updateOrderProductQty"
    };

    this.setState({ isExecuting: true });


    await axios({
      method: "post",
      headers: { "Content-Type": "application/json", },
      url:
        api_urlV2 +
        "/api/orders/update"
      ,
      data: dataDelOrder, //JSON.stringify(dataDelOrder)
    })
      .then((response) => response.data)
      .then((data) => {
        if (data.status) {
          const orders = this.state.orders.filter((e) => e.id !== eventId);
          //console.log("orders", orders)
          this.setState({ orders });
          let monto_total = data.total;
          let sub_total = data.subtotal;
          let descuento = data.descuento;

          var totalProd = 0;
          var totalPicked = 0;
          var product_ids = "";
          for (var key in orders) {
            if (this.esPreventa(orders[key].productSKU)) continue;
            totalProd++;
            if (orders[key].isPicked > 0) {
              product_ids =
                product_ids +
                "|" +
                orders[key].product_id +
                "," +
                orders[key].productQty +
                "," +
                orders[key].productQty;
              totalPicked++;
            }
          }
          if (product_ids.length > 1) {
            product_ids = product_ids.substr(1, product_ids.length);
          }

          //          //console.log(totalPicked);
          //          //console.log(totalProd);
          let progress_i = Math.ceil((totalPicked / totalProd) * 100);

          if (totalProd === 0) {
            progress_i = 100;
          }

          this.setState({
            ...this.state,
            descuento: descuento,
            pre_descuento: descuento,
            monto_total: monto_total,
            sub_total: parseFloat(sub_total, 2).toFixed(2),
          });

          //NUEVA LOGICA POR PICKUP

          // Detect cross-store empty after deletion
          const _affectedStores = [
            ...new Set(
              this.state.mixed_skus
                .filter((m) => m.sku && m.sku.toString() === productSKU.toString())
                .map((m) => m.store)
            ),
          ];
          mixed_skus = mixed_skus.filter(item => item.sku != productSKU);
          skus = skus.filter(item => item.NAME != productSKU);
          // Cambio de alcance 22/10/2026: la preventa no tiene flujo propio por tienda que matar (la atiende el
          // subflujo de preventa, que se pasa con 0 productos en "Picking Preventa"): borrarla no debe proponer
          // eliminar el flujo de la tienda.
          const _eraPreventa = this.esPreventa(productSKU);
          const _emptyStores = _eraPreventa
            ? []
            : _affectedStores.filter(
                (store) => !mixed_skus.some((m) => m.store === store) && store === this.state.officecode
              );
          if (_emptyStores.length) {
            const _warningData = { stores: _emptyStores, status: "pending" };
            this.setState({ crossStoreWarning: _warningData });
            axios({
              url: API_CONFIG.xflowurl + "/engine-users/save-flow-field",
              method: "put",
              data: {
                WO_flowID: this.state.WO_Id,
                WO_TaskID: this.state.WO_TaskId,
                params: [
                  { var: "pending_crossstore_delete", value: JSON.stringify(_warningData) },
                ],
              },
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + this.state.token,
              },
            });
          }


          //console.log("mixed_skus", mixed_skus)
          //console.log("skus", skus)
          /*
          let pos = mixed_skus.findIndex(
            (item) => item.sku.toString() === productSKU.toString()
          );

          let pos2 = skus.findIndex(
            (item) => item.NAME.toString() === productSKU.toString()
          );
          //console.log(pos, pos2);
          if (pos >= 0) {
            mixed_skus.splice(pos, 1);
          }

          if (pos2 >= 0) {
            skus.splice(pos2, 1);
          }
          */

          //NUEVA LOGICA POR PICKUP

          let url = API_CONFIG.xflowurl + "/engine-users/save-flow-field";
          //let url = "http://localhost:4042/api/v1"+"/engine-users/save-flow-field";

          axios({
            url: url,
            method: "put",
            data: {
              WO_flowID: this.state.WO_Id,
              WO_TaskID: this.state.WO_TaskId,
              params: [
                { var: "pedido_modificado", value: "SI" },
                { var: "monto_total", value: monto_total },
                { var: "picking_products_i", value: product_ids },
                { var: "progress_i", value: progress_i },
                { var: "subtotal", value: parseFloat(sub_total, 2).toFixed(2) },
                { var: "skus", value: JSON.stringify(skus) },
                { var: "mixed_skus", value: JSON.stringify(mixed_skus) },
              ],
            },
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.state.token,
            },
          });
          //check!!!
          /*
          url = API_CONFIG.base_url + "/externalApi/updateProductsByOrderID/";
          axios({
            url: url,
            method: "post",
            data: {
              flowId: this.props.match.params.WO_Id,
              order_id: this.state.order_id,
              SKU: productSKU,
              quantity: 0,
              org: this.state.org,
            },
            headers: { apikey: "xflow1506103c404d6dccaf787e44cf123456789" },
          });
          */
          this.updateOrdenesyPagos();
          this.setState({
            isExecuting: false,
            mixed_skus: mixed_skus,
            skus: skus,
          });

          toast.success("OK: Procesado Correctamente", {
            closeButton: true,
          });
          if (_eraPreventa && !orders.some((o) => this.esPreventa(o.productSKU))) {
            toast.info(
              "Ya no quedan productos de preventa en el pedido: la tarea Picking Preventa se podrá completar sin productos.",
              { closeButton: true, autoClose: false }
            );
          }
        } else {
          neworders = [];
          for (var key in this.state.orders) {
            let obj = this.state.orders[key];
            //console.log(obj);
            if (this.state.orders[key].id === eventId) {
              obj["state"] = "error";
              //console.log ("set err")
            }
            neworders.push(obj);
          }
          this.setState({ orders: neworders });
          toast.error("ERROR:" + data.descResp, {
            closeButton: true,
          });

          this.setState({ isExecuting: false });
        }
      });
    this.updateOtherOrder();
  };

  // HU06 Preventa -- marca visual por SKU (rojo = todavia no llego / preventa
  // pendiente, verde = ya se confirmo/volvio a stock normal). Reusa
  // /api/preventa/checkDisponibilidad (mismo endpoint del gate de "Picking
  // Preventa"), que ya devuelve `disponible` por item -- solo trae los items
  // que SON de preventa, asi que un sku ausente en la respuesta simplemente
  // no lleva marca (no es de preventa).
  loadPreventaStatus = async (order_id) => {
    if (!order_id) {
      // Igual se marca cargado -- si no hay order_id no hay nada que
      // esperar, y dejar el gate de handlePick trabado para siempre
      // seria peor que no tener el dato.
      this.setState({ preventaMapLoaded: true });
      return;
    }
    await axios({
      method: "post",
      headers: { "Content-Type": "application/json" },
      url: API_CONFIG.casaideasInt + "/api/preventa/checkDisponibilidad",
      data: { order_id, apikey: API_CONFIG.casaideasIntToken },
    })
      .then((r) => r.data)
      .then((data) => {
        const preventaMap = {};
        (data.items || []).forEach((item) => {
          preventaMap[item.sku] = item.disponible;
        });
        this.setState({ preventaMap, preventaMapLoaded: true });
      })
      .catch(() => {
        // No bloquea la pantalla si falla -- es solo una marca informativa.
        // preventaMapLoaded igual se marca true para no dejar el gate de
        // handlePick trabado para siempre si este endpoint esta caido.
        this.setState({ preventaMapLoaded: true });
      });
  };

  LoadTable = async () => {
    var store_id = 0;
    let params = new URLSearchParams(this.props.location.search);
    applyExternalDarkMode(this.props.location.search);
    let token = params.get("token");
    let WO_Id = params.get("wfpflowid");
    let WO_TaskId = params.get("wfptaskid");
    let locked = params.get("locked") === "true";

    let officecode = params.get("officecode");
    let mixed_skus = [];
    let skus = [];
    let pedido_parcial = "NO";
    var metodo_pago = "";
    var monto_total = "";
    var sub_total = "";
    var sendstore = "";

    let options;
    let formButtons = [];
    //console.log(params)
    if (params.get("options")) {
      options = params.get("options").split(",");
      for (let o in options) {
        if (options[o] !== "Pedido Armado") {
          formButtons.push({ optioncode: "op" + o, optionname: options[o] });
        }
      }
    } else {
      this.setState({ readOnly: true });
    }
    let popup = params.get("popup");

    if (popup) {
      //console.log("popup", popup);
      this.setState({ reload: true });
    }

    formButtons.sort(function (a, b) {
      return b.optionname > a.optionname
        ? -1
        : b.optionname < a.optionname
          ? 1
          : 0;
    });
    //console.log("WO_TaskId", WO_TaskId);

    const storesCatalog = await getCasaIdeasStores();
    let storeCodeI = getStoreCodeByOfficeCode(officecode, storesCatalog);

    this.setState({
      isLoadedTable: false,
      WO_Id: WO_Id,
      WO_TaskId: WO_TaskId,
      loadingData: true,
      token: token,
      formButtons: formButtons,
      officecode: officecode,
      storeCodeI: storeCodeI,
    });

    //console.log("sta", this.state.WO_TaskId);
    //console.log("sta", this.state.WO_Id);

    var order_id = 0;
    var customer_id = 0;
    var nombre_cliente = "";
    var pedido_modificado = "";
    var costo_envio = "";
    var descuento = "";
    var direccion_1 = "";
    var zona = "";

    var paymentName = "";
    var picking_products_i = "";
    var store_url = API_CONFIG.casaideas + "/";
    var tipo_envio_code = "";
    var tipo_envio = "";
    var branch_name = "";
    var org = "CASAIDEAS";
    var tipo_pago = "";
    var progress_i = 0;
    var userId = -1;
    let source = "";
    var flowcode;
    var flowid;
    let taskIdDef = 0;
    var tipo_pedido = "";
    var cupon = "";
    var codigo_cupon = "";
    let NombreTarea = "";
    await axios({
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      url: API_CONFIG.xflowurl + "/engine-users/get-task-details",
      //url : "http://localhost:4042/api/v1"+"/engine-users/get-task-details",
      data: {
        wfptaskid: WO_TaskId,
      },
      method: "post",
    })
      .then((response) => response.data)
      .then((data) => {
        //console.log("data", data);
        if (data.status) {
          flowcode = data.task.FLOWCODE;
          flowid = data.task.FLOWID;
          //si es un de pickup o regalables marcamos
          if (
            flowcode === "flowBolCI07" ||
            flowcode === "flowBolCI08" ||
            flowcode === "flowBolCI06"
          ) {
            //console.log("SI valido")
            taskIdDef = data.task.TASKID;
          }
          let taskName = data.task.TASK;
          this.setState({ taskName: taskName });
          if (taskName === "Pedido Completado") {
            this.setState({ hideSection: true });
          }
          for (let v in data.flowvars) {
            let flowVar = data.flowvars[v];
            if (flowVar.VARNAME === "order_id") {
              order_id = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "customer_id") {
              customer_id = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "nombre_cliente") {
              nombre_cliente = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "pedido_modificado") {
              pedido_modificado = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "shipping_cost") {
              costo_envio = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "discount") {
              descuento = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "direccion_1") {
              direccion_1 = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "zona") {
              zona = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "tipo_envio_code") {
              tipo_envio_code = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "tipo_pago") {
              tipo_pago = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "picking_products_i") {
              picking_products_i = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "progress_i") {
              progress_i = parseInt(flowVar.VARVALUE);
            }

            if (flowVar.VARNAME === "pedido_parcial") {
              pedido_parcial = flowVar.VARVALUE;
            }

            if (flowVar.VARNAME === "branch_name") {
              branch_name = flowVar.VARVALUE;
            }

            if (flowVar.VARNAME === "officecodeONLINE") {
              source = flowVar.VARVALUE;
            }

            if (flowVar.VARNAME === "metodo_pago") {
              //console.log("metodo_pago", flowVar.VARVALUE);

              let varPago = flowVar.VARVALUE;

              if (varPago === "Pago online") {
                varPago = "TODOTIX";
              }
              if (varPago === "Pago QR BCP") {
                varPago = "QR BCP";
              }
              //console.log("varPago", varPago);

              let resultado = this.state.metodos_orig.find(
                (metodo) => metodo.value === varPago
              );
              if (resultado) {
                metodo_pago = varPago;
              }
            }
            if (flowVar.VARNAME === "monto_total") {
              monto_total = flowVar.VARVALUE;
              console.log("monto_total", monto_total)
            }
            if (flowVar.VARNAME === "subtotal") {
              sub_total = flowVar.VARVALUE;
              console.log("sub_total", sub_total)
            }

            if (flowVar.VARNAME === "subtotal") {
              sub_total = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "tipo_envio") {
              tipo_envio = flowVar.VARVALUE;
            }

            if (flowVar.VARNAME === "tipo_pedido") {
              tipo_pedido = flowVar.VARVALUE;
            }

            if (flowVar.VARNAME === "tipo_documento") {
              const tipos_documento = this.state.tipos_documento.map(
                (documento) => {
                  if (documento.text === flowVar.VARVALUE) {
                    return { ...documento, checked: true };
                  }
                  return documento;
                }
              );
              this.setState({ tipos_documento: tipos_documento });
              this.setState({ tipo_documento: flowVar.VARVALUE });
            }

            if (flowVar.VARNAME === "mixed_skus") {
              try {
                mixed_skus = JSON.parse(flowVar.VARVALUE);
              } catch (ex) {
                //console.log("EX", ex);
              }
            }

            if (flowVar.VARNAME === "skus") {
              try {
                skus = JSON.parse(flowVar.VARVALUE);
                //console.log("skus:", skus)
              } catch (ex) {
                //console.log("EX", ex);
              }
            }
            if (flowVar.VARNAME === "pending_crossstore_delete") {
              try {
                const _pending = JSON.parse(flowVar.VARVALUE);
                if (_pending && _pending.status === "pending" && _pending.stores && _pending.stores.length) {
                  this.setState({ crossStoreWarning: _pending });
                }
              } catch (ex) { }
            }
            if (flowVar.VARNAME !== "invoice_user") {
              this.setState({ [flowVar.VARNAME]: flowVar.VARVALUE });
            }
          }
        }
      });

    if (tipo_envio === "event") {
      //console.log("tipo envio", tipo_envio);
      if (tipo_pedido !== "TIENDA SOLO COMPRA") {
        this.setState({
          validaFactura: true,
        });
      } else {
        //console.log("evento sin facturacion");
      }
    }

    var metodos = this.state.metodos_orig;
    for (var k in metodos) {
      let obj = metodos[k];
      if (obj["value"] == metodo_pago) {
        obj["checked"] = true;
      }
    }

    var fcosto_envio = costo_envio ? parseFloat(costo_envio, 2).toFixed(2) : 0;
    var fdescuento = descuento ? parseFloat(descuento, 2).toFixed(2) : 0;
    var fsub_total = sub_total ? parseFloat(sub_total, 2).toFixed(2) : 0;

    /*
    if (flowcode === "flowBolCI02") {
      //console.log("YESSSSSSSSSSS")
      sendstore = "YES";
    }
*/
    console.log("monto_total", metodo_pago, monto_total)
    this.setState({
      ...this.state,
      metodos: metodos,
      metodo_pago: metodo_pago,

    });
    if (metodo_pago === "TODOTIX" || metodo_pago === "QR BCP") {
      this.setState({ monto_real: monto_total });
    }

    axios({
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.token,
      },
      url:
        API_CONFIG.xflowurl +
        "/customcomponents/get-single/resumen_ordenes/id_pedido",
      data: { id: order_id },
      method: "post",
    })
      .then((response) => response.data)
      .then((data) => {
        //console.log("response transaction log execution", data);
        let fechainicio = data.data.FECHAINICIO;
        let fechadeejecucion = data.data.FECHADEEJECUCION;
        let estado = data.data.ESTADO;
        let observaciones = data.data.OBSERVACIONES;
        let nota_sap = data.data.NOTA_SAP;
        let metododepago2 = data.data.METODODEPAGO2;

        this.setState({
          ...this.state,
          fechainicio,
          fechadeejecucion,
          estado,
          observaciones,
          nota_sap,
          metododepago2,
        });
      })
      .catch((error) => {
        //console.log("error transaction log execution", error);
      });

    var paymentName = tipo_pago;
    //console.log(tipo_envio_code, paymentName);
    this.setState({ shippId: tipo_envio_code, pedido_parcial: pedido_parcial });
    var isSupervisor, isAdmin;
    await axios({
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      url: API_CONFIG.xflowurl + "/engine-users/decrypt-token",
      //url : "http://localhost:4042/api/v1"+"/engine-users/decrypt-token",
      method: "post",
    })
      .then((response) => response.data)
      .then((data) => {
        //console.log("data", data);
        if (data.status) {
          userId = data.token.USERID;
          isSupervisor = data.token.USERGROUP === "SINGLEUSER" ? -1 : 1;
          isAdmin = data.token.USERGROUP === "ADMINECOM" ? 1 : -1;
          this.setState({
            ...this.state,
            username: data.token.USERNAME,
            invoice_user: data.token.USERNAME,
            organization: data.token.ORGANIZATIONCODE,
          });
        }
      });

    let url = API_CONFIG.getorderByIdpath;
    let apikey = API_CONFIG.casaideasIntToken;
    if (
      process.env.REACT_APP_BACKEND_CONFIG === "https://backv2.casaideas.com.bo"
    ) {
      url = API_CONFIG.casaideas + "/externalapi/execute/getorderById";
    }
    let imagePath = ""
    await axios({
      url: url,
      method: "post",
      data: {
        apikey: apikey,
        order_id: order_id,
        customer_id: customer_id,
        adminpath: "matrix",
      },
    })
      .then((response) => response.data)
      .then((data) => {
        console.log("data", data);
        let orderInfo = data.response[0].order_info
        var arr = [];
        var i = 0;

        if (data.success) {
          cupon = data.response[0].order_info.codigo_cupon ?? "";
          codigo_cupon = data.response[0].order_info.codigo_cupon_interno ?? "";
          data = {
            resp: "OK",
            rows: data.response[0].products,
          };
        }
        //   //console.log("source", source);

        if (data.resp === "OK" && data.rows.length > 0) {
          //console.log(data.resp);
          var arrayPicked = [];

          if (picking_products_i !== null) {
            arrayPicked = picking_products_i.split("|");
          }

          /*      
          //console.log("data.rows:::", data.rows);
          //console.log("mixed_skus", mixed_skus);
          //console.log("skus", skus, flowcode, pedido_parcial);
          */
          for (var key in data.rows) {
            let _imagePath = data.rows[key].image.split(".com")
            imagePath = _imagePath[0] + ".com"
            store_id = data.rows[0].store_id;
            let storeCatalogItem = null;
            for (let storeIndex = 0; storeIndex < storesCatalog.length; storeIndex++) {
              let store = storesCatalog[storeIndex];
              if (
                String(store.storeId) === String(store_id) ||
                String(store.DETAILDOMAINID) === String(store_id)
              ) {
                storeCatalogItem = store;
                break;
              }
            }
            if (storeCatalogItem && storeCatalogItem.catalogId) {
              store_id = storeCatalogItem.catalogId;
            }

            let isValid = false;
            let _productQty = 0;
            // HU06 pickup en otra tienda (26/09) -- corregido de vuelta a la
            // logica real de produccion, sin tocar. El actor que ejecuta
            // "Picking Individual"/"Traspaso a otra tienda" en flowBolCI07
            // esta FISICAMENTE en la tienda ORIGEN aunque la tarea diga
            // OFFICECODE=pickup -- por eso ve ahi los items de origen
            // (source===sku.store). El companion (misma oficina de pickup,
            // otro actor, fisicamente en la tienda de pickup) ve sus propios
            // items (officecode===sku.store). Esto es solo para STOCK -- la
            // preventa usa un mecanismo distinto (subflujo por tienda), ver
            // TASKID 246/247/248.
            if (pedido_parcial == "SI") {
              //console.log("PARCIAL!!!!!");
              for (let k in mixed_skus) {
                let sku = mixed_skus[k];

                //console.log(this.state)
                if (sku.sku.toString() === data.rows[key].sku.toString()) {
                  if (flowcode === "flowBolCI07") {
                    if (source === sku.store) {
                      _productQty = sku.qty;
                      isValid = true;
                    }
                  } else {
                    //console.log("tienda orig", officecode, sku.store);
                    if (officecode === sku.store) {
                      _productQty = sku.qty;
                      isValid = true;
                    }
                  }
                }
              }
            } else {
              //quitamos _productQty = data.rows[key].quantity;

              //aumentamos
              if (flowcode === "flowBolCI01") {
                _productQty = data.rows[key].quantity;
                isValid = true;
              } else {
                for (let k in mixed_skus) {
                  let sku = mixed_skus[k];

                  if (sku.sku.toString() === data.rows[key].sku.toString()) {
                    if (flowcode === "flowBolCI07") {
                      if (source === sku.store) {
                        _productQty = sku.qty;
                        isValid = true;
                      }
                    } else {
                      //console.log("tienda orig");

                      if (officecode === sku.store) {
                        _productQty = sku.qty;
                        isValid = true;
                      }
                    }
                  }
                }
              }
            }

            if (_productQty === 0) {
              _productQty = data.rows[key].quantity;
            }

            var arrPicked = arrayPicked.filter(function (e) {
              return e.substr(0, e.indexOf(",")) == data.rows[key].product_id;
            });

            var isPicked = -1;
            var qtyPicked = 0;
            if (arrPicked.length > 0) {
              let data = arrPicked[0].split(",");
              if (data[1] == data[2]) {
                isPicked = 1;
              }
              qtyPicked = parseInt(data[1]);
            }
            //console.log("sku", data.rows[key].sku, isValid);

            arr.push({

              id: data.rows[key].id,
              product_id: data.rows[key].product_id,
              productName: data.rows[key].name,
              productModel: data.rows[key].model,
              new_price: data.rows[key].new_price,
              disc_type: data.rows[key].disc_type,
              productPrice: parseFloat(
                data.rows[key].price
                  .replace("Bs.", "")
                  .replace(".", "")
                  .replace(",", ".")
              ).toFixed(2),

              originalPrice: parseFloat(
                data.rows[key].productPrice
                  .replace("Bs.", "")
                  .replace(".", "")
                  .replace(",", ".")
              ).toFixed(2),
              precio_lista: data.rows[key].precio_regular,
              precio: data.rows[key].precio,
              productQty: parseInt(_productQty),
              productImage: data.rows[key].image, //data.store_url+"image/cache/"+img,
              productSKU: data.rows[key].sku,
              state: "loaded",
              isPicked: isPicked,
              qtyPicked: qtyPicked,
              isValid: taskIdDef === 7 ? true : isValid,
            });
          }
        }

        //console.log("arr", arr, taskIdDef);
        //console.log("imagePath", imagePath)
        arr = arr.sort(function (a, b) {
          return b.isValid - a.isValid;
        });

        var fcosto_envio = costo_envio
          ? parseFloat(costo_envio, 2).toFixed(2)
          : 0;

        var fdescuento = descuento ? parseFloat(descuento, 2).toFixed(2) : 0;

        console.log("data.order_info", orderInfo)
        this.setState({
          ...this.state,
          orders: arr,
          codigo_cupon: codigo_cupon,
          cupon: cupon,
          imagePath: imagePath,
          org: org,
          mixed_skus: mixed_skus,
          skus: skus,
          store_id: store_id,
          store_url: store_url,
          isLoadedTable: true,
          customerName: nombre_cliente,
          pedido_parcial: pedido_parcial,
          branch_name: branch_name,
          customerAdd: direccion_1,
          customerZone: zona,
          customer_id: customer_id,
          existingPreviousOrder: false,
          isDeleted: false,
          order_id: order_id,
          //costo_envio: fcosto_envio,
          //descuento: fdescuento,
          //pre_costo_envio: fcosto_envio,
          //pre_descuento: fdescuento,
          isSupervisor: isSupervisor,
          isAdmin: isAdmin,
          progress_i: progress_i,
          userId: userId,
          flowcode: flowcode,
          flowid: flowid,
          monto_total: Number((orderInfo.SUBTOTAL - orderInfo.DISCOUNT + orderInfo.SHIPPINGCOST).toFixed(2)),
          descuento: orderInfo.DISCOUNT,
          pre_descuento: orderInfo.DISCOUNT,
          costo_envio: orderInfo.SHIPPINGCOST,
          sub_total: orderInfo.SUBTOTAL,
          pre_costo_envio: orderInfo.SHIPPINGCOST,
          //loadingData:false,
        });

        this.loadPreventaStatus(order_id);

        if (metodo_pago === "TODOTIX" || metodo_pago === "QR BCP") {
          this.setState({ monto_real: monto_total });
        }

        monto_total = 0;
        sub_total = 0;
        for (var key in this.state.orders) {
          let obj = this.state.orders[key];
          let productPrice = this.state.orders[key].precio > 0 ? this.state.orders[key].precio : this.state.orders[key].precio_lista;
          let productQty = this.state.orders[key].productQty;
          let total = productQty * productPrice;
          monto_total = monto_total + total;
          sub_total = sub_total + total;
        }
        //console.log("monto_total", monto_total, fcosto_envio, fdescuento);
        monto_total = (
          parseFloat(monto_total) +
          parseFloat(fcosto_envio) -
          parseFloat(fdescuento)
        ).toFixed(2);

        //console.log(this.state.store_url, _store_url)
        var dataSH = {
          language_id: 3,
          username: this.state.username,
        };
        var api_urlV2 = API_CONFIG.casaideasInt;
        axios({
          method: "post",
          headers: { "Content-Type": "application/json" },
          url:
            api_urlV2 +
            "/api/frontend/getDomain"
          ,
          data: {
            "domainName": "metodos_envio"
          }, //JSON.stringify(dataDelOrder)
        })
          .then((response) => response.data)
          .then((data) => {
            var shippingTypes = [];
            console.log("data:", data)
            for (var s in data.response) {
              if (data.response[s].id == tipo_envio_code) {
                shippingTypes.push({
                  value: data.response[s].id,
                  text: data.response[s].metodo_envio,
                  type: data.response[s].codigo,
                  checked: true,
                });
              } else {
                shippingTypes.push({
                  value: data.response[s].id,
                  text: data.response[s].metodo_envio,
                  type: data.response[s].codigo,
                });
              }
            }
            this.setState({
              ...this.state,
              shippingTypes: shippingTypes,
            });

            axios({
              method: "post",
              headers: { "Content-Type": "application/json" },
              url:
                api_urlV2 +
                "/api/frontend/getDomain"
              ,
              data: {
                "domainName": "metodos_pago"
              }, //JSON.stringify(dataDelOrder)
            })
              .then((response) => response.data)
              .then((data) => {
                var paymentTypes = [];
                console.log("paymentName", paymentName)
                var payId = 1;
                let metodo_pago = "";
                for (var s in data.response) {
                  if (data.response[s].web === 1) {
                    if (data.response[s].metodo_pago == paymentName) {
                      payId = data.response[s].id;
                      paymentTypes.push({
                        value: data.response[s].id,
                        text: data.response[s].metodo_pago,
                        type: data.response[s].tipo,
                        checked: true,
                      });
                      metodo_pago = data.response[s].metodo_pago;
                    } else {
                      paymentTypes.push({
                        value: data.response[s].id,
                        text: data.response[s].metodo_pago,
                        type: data.response[s].tipo,
                      });
                    }
                  }

                }
                console.log("metodo_pago", metodo_pago);
                console.log("paymentTypes", paymentTypes);
                console.log("tipo_envio", tipo_envio);

                if (tipo_envio === "weight") {
                  if (metodo_pago === "Pago online") {
                    metodo_pago = "TODOTIX";
                    //console.log("ajustando 1", metodo_pago);
                  } else if (metodo_pago === "QR BCP") {
                    metodo_pago = "QR BCP";
                    //console.log("ajustando 2", metodo_pago);
                  } else {
                    metodo_pago = "CONTRAENTREGA";
                    //console.log("ajustando 2", metodo_pago);
                  }
                }
                this.setState({
                  ...this.state,
                  paymentTypes: paymentTypes,
                  payId: payId,
                  metodo_pago: metodo_pago,
                  loadingData: false,
                  locked: locked,
                });
              });
          });
      });
    console.log("THIS", this.state);
  };

  toggleModal = (nr) => () => {
    let modalNumber = "modal" + nr;
    this.setState({
      [modalNumber]: !this.state[modalNumber],
    });
  };

  executeTask = async (option, optionName) => {
    if (this.state.locked) return;
    var responseValidation = true;

    this.setState({ isExecuting: true });

    //console.log("op", option);
    //console.log("op", optionName);
    //console.log("state", this.state);

    let params = {
      comment_external: this.state.observacion,
    };
    //console.log(this.state.progress_i)

    // HU06 Preventa -- no confiar en this.state.progress_i: se hidrata al
    // cargar la tarea leyendo el valor ya persistido en la BD
    // (WFP_TMP_FLOWS_VARS.progress_i), que para cualquier pick hecho antes
    // de este fix quedo calculado contando items de preventa bloqueados en
    // el denominador (isValid no excluye preventa). Mismo gap que se
    // encontro y corrigio en externalForm04.js/executeTask (PR #343) --
    // recalcular en vivo evita que un pedido con picks previos quede
    // "congelado" esperando un pick que nunca va a poder hacerse.
    const liveProgress = (() => {
      const totalProdLive = this.state.orders.filter(this.cuentaParaProgreso).length;
      const totalPickedLive = this.state.orders.filter(
        (o) => this.cuentaParaProgreso(o) && o.isPicked > 0
      ).length;
      return totalProdLive === 0
        ? 100
        : Math.ceil((totalPickedLive / totalProdLive) * 100);
    })();

    //console.log("this.state.pedido_parcial ", this.state);
    if (
      optionName == "Pedido Armado" ||
      optionName == "Pedido listo para entrega" ||
      optionName == "Pedido listo" ||
      optionName == "Listo para entrega" ||
      (optionName == "Picking completado" && this.state.tipo_almacen === "nulo")
    ) {
      if (liveProgress < 100) {
        responseValidation = false;
        toast.warning("Debe pickear todos los productos", {
          closeButton: true,
        });
      }
      // quitamos por facturacion xflow

      if (this.state.TRX === "" && this.debeFacturarAqui()) {
        responseValidation = false;
        toast.warning("Debe completar la TRX", { closeButton: true });
      }
      console.log(
        "this.state.sendstore",
        this.state.sendstore,
        this.state.pedido_parcial
      );

      if (this.state.sendstore !== "YES") {
        if (
          this.state.posicion_rack === "" &&
          this.state.pedido_parcial !== "SI"
        ) {
          responseValidation = false;
          toast.warning("Debe completar la  Posición Rack", {
            closeButton: true,
          });
        }
      }
      if (
        this.state.tipo_envio === "event" &&
        this.state.tipo_pedido !== "TIENDA SOLO COMPRA"
      ) {
        var monto_real = this.state.monto_real;
        var monto_2 = this.state.monto_2;
        var metodo_pago = this.state.metodo_pago;
        var metodo_pago_2 = this.state.metodo_pago_2;
        if (metodo_pago == "") {
          var msj_validacion = "Seleccion el campo metodo de pago";
          toast.warning(msj_validacion, {
            closeButton: true,
          });
          responseValidation = false;
        }

        if (monto_real == "") {
          var msj_validacion = "Complete el campo monto pagado";
          toast.warning(msj_validacion, {
            closeButton: true,
          });
          responseValidation = false;
        } else {
          if (isNaN(monto_real)) {
            var msj_validacion = "El campo monto pagado debe ser numero";
            toast.warning(msj_validacion, {
              closeButton: true,
            });
            responseValidation = false;
          }
        }
        //console.log("metodo_pago_2", metodo_pago_2);
        if (metodo_pago_2 != "") {
          if (monto_2 == "") {
            var msj_validacion = "Complete el campo monto pagado 2";
            toast.warning(msj_validacion, {
              closeButton: true,
            });
            responseValidation = false;
          } else {
            if (isNaN(monto_2)) {
              var msj_validacion = "El campo monto pagado 2 debe ser numero";
              toast.warning(msj_validacion, {
                closeButton: true,
              });
              responseValidation = false;
            }
          }
        }
      }
      if (
        this.state.numero_factura === "" &&
        (this.debeFacturarAqui() ||
          (this.state.tipo_envio === "event" &&
            this.state.tipo_pedido !== "TIENDA SOLO COMPRA"))
      ) {
        responseValidation = false;
        toast.warning("Debe completar la factura", { closeButton: true });
      }
      /*
      if (this.state.razon_social === "" &&
        this.state.pedido_parcial !== "SI") {
        responseValidation = false;
        toast.warning("Debe completar la razon social", { closeButton: true });
      }
      */
      if (this.state.nit === "") {
        responseValidation = false;
        toast.warning("Debe completar el Nit", { closeButton: true });
      }
      if (this.state.direccion_1 === "") {
        responseValidation = false;
        toast.warning("Debe completar la direccion", { closeButton: true });
      }
      /*
      if (this.state.direccion_2===""){
        responseValidation=false
        toast.warning("Debe completar la referencia", { closeButton: true });
      }
      */
      if (this.state.latitude === "") {
        responseValidation = false;
        toast.warning("Debe completar la latitud", { closeButton: true });
      }
      if (this.state.longitude === "") {
        responseValidation = false;
        toast.warning("Debe completar la longitud", { closeButton: true });
      }
      if (this.state.telefono === "") {
        responseValidation = false;
        toast.warning("Debe completar el telefono", { closeButton: true });
      }
      params = {
        TRX: this.state.TRX,
        posicion_rack: this.state.posicion_rack,
        numero_factura: this.state.numero_factura,
        razon_social: this.state.razon_social,
        direccion_1: this.state.direccion_1,

        direccion_2: this.state.direccion_2,
        latitude: this.state.latitude,
        longitude: this.state.longitude,
        telefono: this.state.telefono,
        nit: this.state.nit,
      };

      if (this.debeFacturarAqui()) {
        //console.log("ajustamos por que es delivery");
        params["metodo_pago"] = this.state.metodo_pago;
        params["monto_real"] = this.state.monto_total;
        params["monto_2"] = 0;
        if (this.state.metodo_pago === "CONTRAENTREGA") {
          var f = new Date(this.state.from_date);
          var fecha =
            (f.getDate() < 10 ? "0" + f.getDate() : f.getDate()) +
            "/" +
            (f.getMonth() + 1 < 10
              ? "0" + (f.getMonth() + 1)
              : f.getMonth() + 1) +
            "/" +
            (f.getFullYear() + "");
          params["fecha_pago"] = fecha;
        }
      }

      // Eventos: despues de este picking el pedido ya no pasa por "Registrar entrega", asi que la
      // fecha de pago tambien se envia al cerrar la tarea (Mantis 9012).
      if (this.state.tipo_envio === "event") {
        const fEvento = new Date(this.state.from_date);
        params["fecha_pago"] =
          String(fEvento.getDate()).padStart(2, "0") +
          "/" +
          String(fEvento.getMonth() + 1).padStart(2, "0") +
          "/" +
          fEvento.getFullYear();
      }
    } else if (optionName == "Picking completado") {
      if (liveProgress < 100) {
        responseValidation = false;
        toast.warning("Debe pickear todos los productos", {
          closeButton: true,
        });
      }
    } else {
      if (this.state.observacion === "") {
        responseValidation = false;
        toast.warning("Debe completar la observacion", { closeButton: true });
      }
    }

    if (!responseValidation) {
      //console.log("no");
      this.setState({
        ...this.state,
        responseTask: "NOK",
        isExecuting: false,
        modal6: false,
      });
    } else {
      this.setState({ responseTask: null });

      //console.log("ok", this.state);

      await axios({
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.token,
        },
        url: API_CONFIG.xflowurl + "/engine-users/execute-task",
        //url : "http://localhost:4042/api/v1"+"/engine-users/execute-task",
        data: {
          parentid: this.state.WO_TaskId,
          id: this.state.WO_TaskId,
          isParent: this.state.isParent,
          optionValue: optionName,
          params: params,
        },
        method: "put",
      })
        .then((response) => response.data)
        .then((data) => {
          if (data.status) {
            toast.success("Procesado con exito", {
              closeButton: true,
            });

            if (this.state.reload) {
              setTimeout(async function () {
                //console.log("popup");
                window.opener.postMessage("TAREA_COMPLETADA", "*");
                window.close();
              }, 1000);
              try {
                //window.opener.location.reload();
              } catch (ex) {
                //console.log("error closing");
              }
            } else {
              //console.log("dialog");
              setTimeout(async function () {
                window.parent.postMessage("TAREA_COMPLETADA", "*");
              }, 1000);
            }
          } else {
            toast.error("Error ejecutando tareas, mensaje:" + data.message, {
              closeButton: true,
            });
          }
          this.setState({
            ...this.state,
            isExecuting: false,
            modal6: false,
          });
        });
    }
  };

  render() {
    return (
      <>
        <MDBContainer
          className="xext-page xext-form06"
          style={{ maxWidth: "1024px", width: "100%" }}
        >
          <LockOverlay visible={this.state.locked && !this.state.loadingData} />
          {this.state.loadingData ? (
            <Loader idLoading={this.state.loadingData} />
          ) : (
            <>
              <Loader idLoading={this.state.isExecuting} />

              <h3 className="xext-page-title xext-page-title--compact">
                {" "}
                {"Pedido #" + this.state.order_id}
              </h3>

              <div className="xext-summary-grid">
                <div className="xext-summary-item">
                  <span className="xext-summary-label">SubTotal</span>
                  <strong className="xext-summary-value">
                    {this.state.sub_total + " Bs."}
                  </strong>
                </div>
                <div className="xext-summary-item">
                  <span className="xext-summary-label">Descuento</span>
                  <strong className="xext-summary-value">
                    {this.state.descuento + " Bs."}
                  </strong>
                </div>
                <div className="xext-summary-item">
                  <span className="xext-summary-label">Costo de Envio</span>
                  <strong className="xext-summary-value">
                    {this.state.costo_envio + " Bs."}
                  </strong>
                </div>
                <div className="xext-summary-item xext-summary-item--total">
                  <span className="xext-summary-label">Total</span>
                  <strong className="xext-summary-value">
                    {this.state.monto_total + " Bs."}
                  </strong>
                </div>
              </div>

              {this.state.existingPreviousOrder ? (
                <MDBCard style={{ width: "100%" }} className="mb-3 xext-section-card">
                  <MDBRow className="align-items-left justify-content-left">
                    <MDBCol md="12">
                      <MDBAlert className="text-left align-top">
                        <h3 className="h3-responsive font-weight-bold mr-3">
                          <MDBIcon icon="exclamation-circle" className="mr-1" />{" "}
                          El cliente {this.state.customerName} tiene un pedido
                          aun no entregado
                        </h3>
                      </MDBAlert>
                    </MDBCol>
                  </MDBRow>

                  <hr />
                  <MDBRow className="text-right">
                    <MDBCol md="12">
                      <XBtn
                        size="sm"
                        color="primary"
                        onClick={() => {
                          this.setState({ modal4: true });
                        }}
                      >
                        {" "}
                        Revisar Pedido
                      </XBtn>

                      <XBtn
                        size="sm"
                        disabled={this.state.isDeleted}
                        color="danger"
                        onClick={() => {
                          //	this.deleteShipping("1616");
                          this.setState({
                            modal5: true,
                            mensaje: "eliminar la tarifa?",
                            accion: "eliminar tarifa",
                          });
                        }}
                      >
                        {" "}
                        Eliminar Tarifa de envio
                      </XBtn>
                    </MDBCol>
                  </MDBRow>
                </MDBCard>
              ) : (
                ""
              )}

              {!this.state.hideSection && (
                <>
                  {this.state.isSupervisor > 0 ? (
                    <MDBRow className="text-right mt-1 mb-3">
                      <MDBCol size="12" sm="12" md="6" lg="4">
                        <XBtn
                          size="sm"
                          color="success"
                          onClick={() => {
                            this.setState({
                              modal3: true,
                              disabledAdd: true,
                              /*SKUcode:"" , */ productName: "",
                              productPrice: "",
                              productQty: "1",
                            });
                          }}
                        >
                          {" "}
                          <MDBIcon icon="cart-plus" /> Agregar Producto
                        </XBtn>
                      </MDBCol>
                    </MDBRow>
                  ) : (
                    ""
                  )}

                  <MDBRow className="text-left mt-1 mb-3 xext-scan-section">
                    <MDBCol
                      col="11"
                      sm="11"
                      md="6"
                      lg="4"
                      className="col-11 ml-2 mr-2 text-left left no-border"
                    >
                      <div className="xext-scan-card">
                        <div className="barcode-input-row">
                          <div className="barcode-input-field">
                            <XInput
                              id={"read_sku"}
                              key={"read_sku"}
                              name={"read_sku"}
                              className="input-sku"
                              label="Leer SKU"
                              placeholder="Ingrese o escanee el código"
                              value={this.state.read_sku}
                              onChange={this.changeHandlerSKU}
                              size="sm"
                            />
                          </div>
                          <BarcodeScanner
                            disabled={this.state.isExecuting}
                            onDetected={this.handleBarcodeDetected}
                          />
                        </div>
                      </div>
                    </MDBCol>
                    {/**
                  <MDBCol  col= "3" sm="3" md="3" lg="1"  className="col-3 ml-2 mr-2 text-left left no-border"> 
                  <div style={{
                      fontSize:"1rem",
                      fontWeight:"600",
                      color:"#0062cc"
                    }}>Cantidad</div>
                  <XInput
                      
                      id={"qty_sku" }
                      key={"qty_sku" }
                      name={"qty_sku"}
                      className="qty-sku"
                      style={{border: "1px solid #0062cc" , borderRadius: 8  }}
                        value={this.state.qty_sku}
                        onChange={this.changeHandler}
                        size="sm"
                          />
                  </MDBCol>
                  */}
                  </MDBRow>

                  {this.state.isAdmin > 0 ? (
                    <MDBCard className="xext-admin-card mx-auto my-4">
                      <MDBCardBody className="xext-admin-card-body">
                        <MDBRow className="my-4 xext-admin-row">
                          <MDBCol
                            size="12"
                            sm="12"
                            md="7"
                            lg="7"
                            className="text-left left"
                          >
                            <XInput
                              style={{ margin: "0" }}
                              id={"pre_descuento"}
                              key={"pre_descuento"}
                              name={"pre_descuento"}
                              value={this.state.pre_descuento}
                              readOnly={true}
                              size="sm"
                              label="Descuento"
                            />
                          </MDBCol>

                          <MDBCol size="12" sm="12" md="5" lg="5" />
                        </MDBRow>

                        <MDBRow className="my-4 xext-admin-row">
                          <MDBCol
                            size="12"
                            sm="12"
                            md="7"
                            lg="7"
                            className="text-left left"
                          >
                            <XSelect
                              key="store"
                              style={{ margin: 0 }}
                              id="paymentType"
                              color="primary"
                              getValue={this.selectHandler2}
                              options={this.state.paymentTypes}
                              label="Tipo de Pago"
                            />
                          </MDBCol>

                          <MDBCol
                            size="12"
                            sm="12"
                            md="5"
                            lg="5"
                            className="text-right xext-admin-action"
                          >
                            <XBtn
                              className="xext-admin-btn"
                              size="sm"
                              color="primary"
                              disabled={this.state.readOnly}
                              onClick={() => {
                                this.setState({
                                  modal5: true,
                                  mensaje: "Cambiar Tipo de Pago?",
                                  accion: "cambiar pago",
                                });
                              }}
                            >
                              {" "}
                              Actualizar
                            </XBtn>
                          </MDBCol>
                        </MDBRow>

                        <MDBRow className="my-4 xext-admin-row">
                          <MDBCol
                            size="12"
                            sm="12"
                            md="7"
                            lg="7"
                            className="text-left left"
                          >
                            <XSelect
                              key="store"
                              style={{ margin: 0 }}
                              id="shippingType"
                              color="primary"
                              getValue={this.selectHandler1}
                              options={this.state.shippingTypes}
                              label="Tipo de Envio"
                            />
                          </MDBCol>

                          <MDBCol
                            size="12"
                            sm="12"
                            md="5"
                            lg="5"
                            className="text-right xext-admin-action"
                          >
                            <XBtn
                              className="xext-admin-btn"
                              size="sm"
                              color="primary"
                              disabled={this.state.readOnly}
                              onClick={() => {
                                this.setState({
                                  modal5: true,
                                  mensaje: "Cambiar Tipo de Envio?",
                                  accion: "cambiar envio",
                                });
                              }}
                            >
                              {" "}
                              Actualizar
                            </XBtn>
                          </MDBCol>
                        </MDBRow>
                        <MDBRow className="my-4 xext-admin-row">
                          <MDBCol
                            size="12"
                            sm="12"
                            md="7"
                            lg="7"
                            className="text-left left"
                          >
                            <XInput
                              id={"pre_costo_envio"}
                              key={"pre_costo_envio"}
                              name={"pre_costo_envio"}
                              value={this.state.pre_costo_envio}
                              onChange={this.changeHandler}
                              size="sm"
                              label="Costo de envio"
                            />
                          </MDBCol>

                          <MDBCol
                            size="12"
                            sm="12"
                            md="5"
                            lg="5"
                            className="text-right xext-admin-action"
                          >
                            <XBtn
                              className="xext-admin-btn"
                              size="sm"
                              color="primary"
                              disabled={this.state.readOnly}
                              onClick={() => {
                                this.setState({
                                  modal5: true,
                                  mensaje: "Actualizar costo de envio?",
                                  accion: "actualizar costo de envio",
                                });
                              }}
                            >
                              {" "}
                              Actualizar
                            </XBtn>
                          </MDBCol>
                        </MDBRow>
                      </MDBCardBody>
                    </MDBCard>
                  ) : (
                    ""
                  )}
                  {this.state.loadingData
                    ? ""
                    : this.state.orders.map((event) => {
                      const _skuEntry = this.state.mixed_skus
                        ? this.state.mixed_skus.find(
                          (m) => m.sku && m.sku.toString() === event.productSKU.toString()
                        )
                        : null;
                      const _storePill = _skuEntry ? _skuEntry.store : null;
                      const _isOtherStore = _storePill && _storePill !== this.state.officecode;
                      return (
                        <p key={"event1" + event.id} style={{ width: "98%" }}>
                          {this.state.readOnly ? (
                            <Event
                              id={event.id}
                              product_id={event.product_id}
                              productName={event.productName}
                              productQty={event.productQty}
                              precio={event.precio}
                              precio_lista={event.precio_lista}
                              productPrice={event.productPrice}
                              productModel={event.productModel}
                              productImage={event.productImage}
                              productSKU={event.productSKU}
                              onPrice={this.handlePrice}
                              handleChangePrice={this.handleChangePrice}
                              state={event.state}
                              isPicked={event.isPicked}
                              onDelete={null}
                              onEdit={null}
                              onPick={null}
                              isSupervisor={false}
                              isAdmin={false}
                              preventaStatus={this.state.preventaMap[event.productSKU]}
                            />
                          ) : (
                            <Event
                              id={event.id}
                              product_id={event.product_id}
                              productName={event.productName}
                              productQty={event.productQty}
                              productPrice={event.productPrice}
                              productModel={event.productModel}
                              productImage={event.productImage}
                              precio={event.precio}
                              precio_lista={event.precio_lista}
                              productSKU={event.productSKU}
                              onPrice={this.handlePrice}
                              handleChangePrice={this.handleChangePrice}
                              state={event.state}
                              isPicked={event.isPicked}
                              onDelete={
                                event.isValid || this.esPreventa(event.productSKU) ? this.handleDelete : null
                              }
                              onEdit={event.isValid || this.esPreventa(event.productSKU) ? this.handleEdit : null}
                              onPick={event.isValid ? this.handlePick : null}
                              isSupervisor={
                                event.isValid ? this.state.isSupervisor : false
                              }
                              isAdmin={
                                event.isValid ? this.state.isAdmin : false
                              }
                              isValid={event.isValid}
                              isExecuting={this.state.isExecuting}
                              storePill={_storePill}
                              isOtherStore={_isOtherStore}
                              preventaStatus={this.state.preventaMap[event.productSKU]}
                            />
                          )}
                        </p>
                      );
                    })}

                  {this.state.crossStoreWarning && (
                    <div className="xext-crossstore-alert">
                      <div className="xext-crossstore-alert-body">
                        <MDBIcon icon="exclamation-triangle" className="xext-crossstore-alert-icon" />
                        <div>
                          <strong>Atención:</strong> Al eliminar este producto la tienda{" "}
                          <strong>{this.state.crossStoreWarning.stores.join(", ")}</strong>{" "}
                          quedó sin productos en el pedido mixto.
                        </div>
                      </div>
                      <div className="xext-crossstore-alert-actions">
                        {this.state.crossStoreWarning.stores.map((store) => (
                          <XBtn
                            key={store}
                            size="sm"
                            color="danger"
                            onClick={() => this.handleDeleteOtherFlow(store)}
                          >
                            <MDBIcon icon="trash-alt" /> Eliminar flujo de {store}
                          </XBtn>
                        ))}
                        <XBtn
                          size="sm"
                          outline
                          color="secondary"
                          onClick={() => this.setState({ crossStoreWarning: null })}
                        >
                          Ignorar
                        </XBtn>
                      </div>
                    </div>
                  )}
                </>
              )}
              {this.state.hideSection && (
                <>
                  <MDBRow>
                    <MDBCol size="12" className="text-left">
                      <h4
                        style={{
                          zIndex: "1000",
                          fontWeight: "400",
                          color: "#000",
                        }}
                      >
                        {" "}
                        Detalle de la orden{" "}
                      </h4>
                    </MDBCol>
                  </MDBRow>
                  {this.state.orders.map((event) => (
                    <p
                      className="ml-1"
                      key={"event1" + event.id}
                      style={{ width: "98%" }}
                    >
                      <Event
                        id={event.id}
                        isValid={event.isValid}
                        product_id={".000" + event.product_id}
                        productName={event.productName}
                        productQty={event.productQty}
                        productPrice={event.productPrice}
                        productModel={event.productModel}
                        productImage={event.productImage}
                        productSKU={event.productSKU}
                        precio={event.precio}
                        precio_lista={event.precio_lista}
                        state={event.state}
                        onDelete={null}
                        onEdit={null}
                        onPick={null}
                      />
                    </p>
                  ))}
                </>
              )}

              <MDBRow>
                <MDBCol
                  size="12"
                  sm="6"
                  md="6"
                  lg="6"
                  xl="6"
                  className="text-right mt-4"
                >
                  <XInput
                    style={{ margin: "0" }}
                    id={"posicion_rack"}
                    key={"posicion_rack"}
                    name={"posicion_rack"}
                    value={this.state.posicion_rack}
                    onChange={this.changeHandler}
                    size="sm"
                    label="Posición Rack"
                  />
                </MDBCol>

                {this.state.tipo_envio === "event" &&
                  this.state.tipo_pedido !== "TIENDA SOLO COMPRA" && (
                    <MDBRow className="ml-1 mt-2" style={{ width: "99%" }}>
                      <MDBCol sm="12" md="6" lg="6" className="text-left">
                        <XDatePicker
                          label="Fecha de pago"
                          key="from"
                          name="from"
                          id="from"
                          format="DD/MM/YYYY"
                          value={this.state.from_date}
                          cancelLabel="Cancelar"
                          getValue={this.getPickerValueFrom}
                        />
                      </MDBCol>
                    </MDBRow>
                  )}

                {
                  /*this.state.sendstore === "YES" ||*/ this.state
                    .tipo_envio === "event" &&
                  this.state.tipo_pedido !== "TIENDA SOLO COMPRA" && (
                    <>
                      <MDBRow className="ml-1" style={{ width: "99%" }}>
                        <MDBCol
                          sm="12"
                          md="6"
                          lg="6"
                          className=" text-left left"
                        >
                          <XSelect

                            key="metodo_pago"
                            id="metodo_pago"
                            color="primary"
                            getValue={this.selectHandler3}
                            options={this.state.metodos}
                            label="Método de Pago"
                          />
                        </MDBCol>
                        <MDBCol
                          sm="12"
                          md="6"
                          lg="6"
                          className=" text-left left"
                        >
                          <XInput
                            name="monto_real"
                            onChange={this.changeHandler}
                            type="text"
                            id="monto_real"
                            key="monto_real"
                            value={this.state.monto_real}
                            label="Monto Pagado"
                            required
                          ></XInput>
                        </MDBCol>
                      </MDBRow>

                      <MDBRow className="ml-1" style={{ width: "99%" }}>
                        <MDBCol
                          sm="12"
                          md="6"
                          lg="6"
                          className=" text-left left"
                        >
                          <XSelect

                            key="metodo_pago_2"
                            id="metodo_pago_2"
                            color="primary"
                            getValue={this.selectHandler4}
                            options={this.state.metodos2}
                            label="Metodo de Pago 2"
                          />
                        </MDBCol>

                        <MDBCol
                          sm="12"
                          md="6"
                          lg="6"
                          className=" text-left left"
                        >
                          <XInput
                            name="monto_2"
                            onChange={this.changeHandler}
                            type="text"
                            id="monto_2"
                            key="monto_2"
                            disabled={
                              this.state.metodo_pago_2 == "" ? true : false
                            }
                            value={this.state.monto_2}
                            label="Monto pagado 2"
                            required
                          ></XInput>
                        </MDBCol>
                      </MDBRow>

                      <MDBRow className="ml-1" style={{ width: "99%" }}>
                        <MDBCol size="12" sm="12" md="6" lg="6">
                          <div
                            style={{
                              border: "1px solid #00c851",
                              padding: 5,
                              borderRadius: 5,
                            }}
                          >
                            <h5>Facturación en linea</h5>{" "}
                            {this.state.tipo_pedido}
                            {this.state.invoice_status ===
                              "EJECUTADO CORRECTAMENTE" ||
                              this.state.invoice_status === "BYPASS" ? (
                              <MDBAlert
                                color="info"
                                className="d-flex align-items-center"
                              >
                                <MDBIcon
                                  icon="info-circle"
                                  className="mr-2"
                                />
                                Factura ya generada
                              </MDBAlert>
                            ) : (
                              <XBtn
                                className="xext-invoice-generate-btn"
                                size="sm"
                                color="success"
                                onClick={() => {
                                  //console.log("thiss", this.state);
                                  if (this.state.metodo_pago === "") {
                                    toast.error(
                                      "Por favor escoja un Métdoo de pago",
                                      {
                                        closeButton: true,
                                      }
                                    );
                                  } else {
                                    this.setState({
                                      modal33: true,
                                    });
                                  }
                                }}
                              >
                                <MDBIcon icon="file-invoice" /> Generar
                                Factura
                              </XBtn>
                            )}
                            <div style={{ borderTop: "1px solid #00c851" }}>
                              <MDBRow>
                                <MDBCol
                                  sm="12"
                                  md="6"
                                  lg="6"
                                  className=" text-left left"
                                >
                                  Número Factura:
                                </MDBCol>
                                <MDBCol
                                  sm="12"
                                  md="6"
                                  lg="6"
                                  className=" text-left left"
                                >
                                  {this.state.numero_factura == ""
                                    ? "0"
                                    : this.state.numero_factura}
                                  <input
                                    type="hidden"
                                    value={this.state.numero_factura}
                                  />
                                </MDBCol>
                              </MDBRow>

                              <MDBRow>
                                <MDBCol
                                  sm="12"
                                  md="6"
                                  lg="6"
                                  className=" text-left left"
                                >
                                  Respuesta:
                                </MDBCol>
                                <MDBCol
                                  sm="12"
                                  md="6"
                                  lg="6"
                                  className=" text-left left"
                                >
                                  {this.state.invoice_status}
                                </MDBCol>
                              </MDBRow>
                              <MDBRow>
                                <MDBCol
                                  sm="12"
                                  md="6"
                                  lg="6"
                                  className=" text-left left"
                                >
                                  Descripción:
                                </MDBCol>
                                <MDBCol
                                  sm="12"
                                  md="6"
                                  lg="6"
                                  className=" text-left left"
                                >
                                  {this.state.invoice_status !=
                                    "PENDIENTE" ? (
                                    <>
                                      <MDBAlert
                                        color={
                                          this.state.invoice_status ===
                                            "EJECUTADO CON ERROR"
                                            ? "danger"
                                            : "success"
                                        }
                                        className="d-flex align-items-center"
                                      >
                                        <MDBIcon
                                          icon={
                                            this.state.invoice_status ===
                                              "EJECUTADO CON ERROR"
                                              ? "times-circle"
                                              : "check-circle"
                                          }
                                          className="mr-2"
                                        />
                                        {this.state.invoice_response}
                                        <MDBIcon
                                          icon="file-invoice-dollar"
                                          className="mr-2 text-success"
                                          title="Factura válida"
                                        />
                                      </MDBAlert>
                                    </>
                                  ) : (
                                    <>{this.state.invoice_response}</>
                                  )}
                                </MDBCol>
                              </MDBRow>
                            </div>
                          </div>
                        </MDBCol>

                        <MDBCol
                          size="12"
                          sm="6"
                          md="6"
                          lg="6"
                          xl="6"
                          className="text-right"
                        >
                          <XInput
                            style={{ margin: "0" }}
                            id={"TRX"}
                            key={"TRX"}
                            name={"TRX"}
                            disabled={this.state.invoice_status !== "BYPASS"}
                            readonly={this.state.invoice_status !== "BYPASS"}
                            value={this.state.TRX}
                            onChange={this.changeHandler}
                            size="sm"
                            label="TRX"
                          />

                          {this.state.invoice_status === "BYPASS" && (
                            <XInput
                              className="mt-3"
                              id={"numero_factura"}
                              key={"numero_factura"}
                              name={"numero_factura"}
                              disabled={
                                this.state.invoice_status !== "BYPASS"
                              }
                              readonly={
                                this.state.invoice_status !== "BYPASS"
                              }
                              value={this.state.numero_factura}
                              onChange={this.changeHandler}
                              size="sm"
                              label="Número Factura"
                            />
                          )}
                        </MDBCol>
                      </MDBRow>
                    </>
                  )
                }

                {this.debeFacturarAqui() && (
                  <>
                    <MDBCol
                      size="12"
                      sm="6"
                      md="6"
                      lg="6"
                      xl="6"
                      className="text-right mt-4"
                    >
                      <XInput
                        style={{ margin: "0" }}
                        id={"metodo_pago"}
                        key={"metodo_pago"}
                        name={"metodo_pago"}
                        readOnly={true}
                        value={this.state.metodo_pago}
                        onChange={this.changeHandler}
                        size="sm"
                        label="Método de Pago"
                      />
                    </MDBCol>
                    <MDBCol
                      size="12"
                      sm="6"
                      md="6"
                      lg="6"
                      xl="6"
                      className="text-right mt-4"
                    >
                      <XInput
                        style={{ margin: "0" }}
                        id={"monto_total"}
                        key={"monto_total"}
                        name={"monto_total"}
                        readOnly={true}
                        value={this.state.monto_total}
                        onChange={this.changeHandler}
                        size="sm"
                        label="Monto a Pagar"
                      />
                    </MDBCol>

                    <MDBCol sm="12" md="6" lg="6" className="pt-3 text-left">
                      <XDatePicker
                        label="Fecha de pago"
                        key="from"
                        name="from"
                        id="from"
                        format="DD/MM/YYYY"
                        value={this.state.from_date}
                        cancelLabel="Cancelar"
                        getValue={this.getPickerValueFrom}
                      />
                    </MDBCol>
                  </>
                )}

                {this.state.pedido_parcial !== "SI" && (
                  <>
                    {" "}
                    {/*
                    <MDBCol
                      size="12"
                      sm="6"
                      md="6"
                      lg="6"
                      xl="6"
                      className="text-right mt-4"
                    >
                    
                      <XInput
                        style={{ margin: "0" }}
                        id={"TRX"}
                        key={"TRX"}
                        name={"TRX"}
                        disabled={this.state.invoice_status !== "BYPASS"}
                        readonly={this.state.invoice_status !== "BYPASS"}
                        value={this.state.TRX}
                        onChange={this.changeHandler}
                        size="sm"
                        label="TRX"
                      />
                      
                    </MDBCol> */}
                    {this.debeFacturarAqui() &&
                      this.state.taskName !== "Seguimiento de Pedidos" && (
                        <>
                          <MDBCol
                            size="12"
                            sm="12"
                            md="6"
                            lg="6"
                            className="text-left mt-3"
                          >
                            <div
                              style={{
                                border: "1px solid #00c851",
                                padding: 5,
                                borderRadius: 5,
                              }}
                            >
                              <h5> Facturación en linea</h5>

                              {this.state.invoice_status ===
                                "EJECUTADO CORRECTAMENTE" ||
                                this.state.invoice_status === "BYPASS" ? (
                                <MDBAlert
                                  color="info"
                                  className="d-flex align-items-center"
                                >
                                  <MDBIcon
                                    icon="info-circle"
                                    className="mr-2"
                                  />
                                  Factura generada
                                </MDBAlert>
                              ) : (
                                <XBtn
                                  className="xext-invoice-generate-btn"
                                  size="sm"
                                  color="success"
                                  onClick={() => {
                                    //console.log("thiss", this.state);
                                    if (this.state.metodo_pago === "") {
                                      toast.error(
                                        "Por favor escoja un Métdoo de pago",
                                        {
                                          closeButton: true,
                                        }
                                      );
                                    } else {
                                      this.setState({
                                        modal33: true,
                                      });
                                    }
                                  }}
                                >
                                  <MDBIcon icon="file-invoice" /> Generar
                                  Factura
                                </XBtn>
                              )}

                              <div style={{ borderTop: "1px solid #00c851" }}>
                                <MDBRow>
                                  <MDBCol
                                    sm="12"
                                    md="6"
                                    lg="6"
                                    className=" text-left left"
                                  >
                                    Número Factura:
                                  </MDBCol>
                                  <MDBCol
                                    sm="12"
                                    md="6"
                                    lg="6"
                                    className=" text-left left"
                                  >
                                    {this.state.numero_factura == ""
                                      ? "0"
                                      : this.state.numero_factura}
                                    <input
                                      type="hidden"
                                      value={this.state.numero_factura}
                                    />
                                  </MDBCol>
                                </MDBRow>

                                <MDBRow>
                                  <MDBCol
                                    sm="12"
                                    md="6"
                                    lg="6"
                                    className=" text-left left"
                                  >
                                    Respuesta:
                                  </MDBCol>
                                  <MDBCol
                                    sm="12"
                                    md="6"
                                    lg="6"
                                    className=" text-left left"
                                  >
                                    {this.state.invoice_status}
                                  </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                  <MDBCol
                                    sm="12"
                                    md="6"
                                    lg="6"
                                    className=" text-left left"
                                  >
                                    Descripción:
                                  </MDBCol>
                                  <MDBCol
                                    sm="12"
                                    md="6"
                                    lg="6"
                                    className=" text-left left"
                                  >
                                    {this.state.invoice_status !=
                                      "PENDIENTE" ? (
                                      <>
                                        <MDBAlert
                                          color={
                                            this.state.invoice_status ===
                                              "EJECUTADO CON ERROR"
                                              ? "danger"
                                              : "success"
                                          }
                                          className="d-flex align-items-center"
                                        >
                                          <MDBIcon
                                            icon={
                                              this.state.invoice_status ===
                                                "EJECUTADO CON ERROR"
                                                ? "times-circle"
                                                : "check-circle"
                                            }
                                            className="mr-2"
                                          />
                                          {this.state.invoice_response}
                                          <MDBIcon
                                            icon="file-invoice-dollar"
                                            className="mr-2 text-success"
                                            title="Factura válida"
                                          />
                                        </MDBAlert>
                                      </>
                                    ) : (
                                      <>{this.state.invoice_response}</>
                                    )}
                                  </MDBCol>
                                </MDBRow>
                              </div>
                            </div>
                          </MDBCol>

                          <MDBCol
                            size="12"
                            sm="6"
                            md="6"
                            lg="6"
                            xl="6"
                            className="text-right mt-3"
                          >
                            <XInput
                              style={{ margin: "0" }}
                              id={"TRX"}
                              key={"TRX"}
                              name={"TRX"}
                              disabled={this.state.invoice_status !== "BYPASS"}
                              readonly={this.state.invoice_status !== "BYPASS"}
                              value={this.state.TRX}
                              onChange={this.changeHandler}
                              size="sm"
                              label="TRX"
                            />
                            {this.state.invoice_status === "BYPASS" && (
                              <XInput
                                style={{ margin: "0" }}
                                id={"numero_factura"}
                                key={"numero_factura"}
                                name={"numero_factura"}
                                disabled={
                                  this.state.invoice_status !== "BYPASS"
                                }
                                readonly={
                                  this.state.invoice_status !== "BYPASS"
                                }
                                value={this.state.numero_factura}
                                onChange={this.changeHandler}
                                size="sm"
                                label="Número Factura"
                              />
                            )}
                          </MDBCol>
                        </>
                      )}
                  </>
                )}

                {(this.state.taskName == "Seguimiento de Pedidos" ||
                  this.state.taskName == "Pedido observado post venta") && (
                  /*this.state.invoice_status === "EJECUTADO CORRECTAMENTE" &&*/ <MDBRow
                      className="ml-1 mt-3"
                      style={{ width: "99%" }}
                    >
                      <MDBCol size="12" sm="12" md="6" lg="6">
                        <div
                          style={{
                            border: "1px solid #00c851",
                            padding: 5,
                            borderRadius: 5,
                          }}
                        >
                          <h5>Información de la factura para anulación</h5>

                          {this.state.anulacion_invoice_status ===
                            "EJECUTADO CORRECTAMENTE" &&
                            this.state.invoice_status !== "BYPASS" ? (
                            <MDBAlert
                              color="info"
                              className="d-flex align-items-center"
                            >
                              <MDBIcon icon="info-circle" className="mr-2" />
                              Factura anulada
                            </MDBAlert>
                          ) : this.state.invoice_status === "PENDIENTE" ||
                            this.state.invoice_status === "" ? (
                            <b>Factura aun no generada, NO SE PUEDE ANULAR</b>
                          ) : (
                            <XBtn
                              size="sm"
                              color="success"
                              onClick={() => {
                                this.setState({
                                  modal34: true,
                                });
                              }}
                            >
                              <MDBIcon icon="file-invoice" /> Anular Factura
                            </XBtn>
                          )}
                          <div style={{ borderTop: "1px solid #00c851" }}>
                            <MDBRow>
                              <MDBCol
                                sm="12"
                                md="6"
                                lg="6"
                                className=" text-left left"
                              >
                                Número Factura:
                              </MDBCol>
                              <MDBCol
                                sm="12"
                                md="6"
                                lg="6"
                                className=" text-left left"
                              >
                                {this.state.numero_factura == ""
                                  ? "0"
                                  : this.state.numero_factura}
                                <input
                                  type="hidden"
                                  value={this.state.numero_factura}
                                />
                              </MDBCol>
                            </MDBRow>

                            <MDBRow>
                              <MDBCol
                                sm="12"
                                md="6"
                                lg="6"
                                className=" text-left left"
                              >
                                TRX:
                              </MDBCol>
                              <MDBCol
                                sm="12"
                                md="6"
                                lg="6"
                                className=" text-left left"
                              >
                                {this.state.TRX == "" ? "0" : this.state.TRX}
                                <input type="hidden" value={this.state.TRX} />
                              </MDBCol>
                            </MDBRow>

                            <MDBRow>
                              <MDBCol
                                sm="12"
                                md="6"
                                lg="6"
                                success
                                className=" text-left left"
                              >
                                Respuesta Anulación:
                              </MDBCol>
                              <MDBCol
                                sm="12"
                                md="6"
                                lg="6"
                                className=" text-left left"
                              >
                                {this.state.anulacion_invoice_status}
                              </MDBCol>
                            </MDBRow>
                            <MDBRow>
                              <MDBCol
                                sm="12"
                                md="6"
                                lg="6"
                                className=" text-left left"
                              >
                                Descripción:
                              </MDBCol>
                              <MDBCol
                                sm="12"
                                md="6"
                                lg="6"
                                className=" text-left left"
                              >
                                {this.state.anulacion_invoice_status &&
                                  this.state.anulacion_invoice_status.trim() !==
                                  "" &&
                                  this.state.anulacion_invoice_status !==
                                  "PENDIENTE" ? (
                                  <>
                                    <MDBAlert
                                      color={
                                        this.state.anulacion_invoice_status ===
                                          "EJECUTADO CON ERROR"
                                          ? "danger"
                                          : "success"
                                      }
                                      className="d-flex align-items-center"
                                    >
                                      <MDBIcon
                                        icon={
                                          this.state.anulacion_invoice_status ===
                                            "EJECUTADO CON ERROR"
                                            ? "times-circle"
                                            : "check-circle"
                                        }
                                        className="mr-2"
                                      />
                                      {this.state.anulacion_invoice_response}
                                      <MDBIcon
                                        icon="unlink"
                                        className="ml-2 text-warning"
                                        title="Operación anulada"
                                      />
                                    </MDBAlert>
                                  </>
                                ) : (
                                  <>{this.state.anulacion_invoice_response}</>
                                )}
                              </MDBCol>
                            </MDBRow>
                          </div>
                        </div>
                      </MDBCol>

                      <MDBCol
                        size="12"
                        sm="6"
                        md="6"
                        lg="6"
                        xl="6"
                        className="text-right"
                      ></MDBCol>
                    </MDBRow>
                  )}

                <MDBCol
                  size="12"
                  sm="6"
                  md="6"
                  lg="6"
                  xl="6"
                  className="text-right mt-4"
                >
                  <XInput
                    style={{ margin: "0" }}
                    id={"direccion_1"}
                    key={"direccion_1"}
                    name={"direccion_1"}
                    value={this.state.direccion_1}
                    onChange={this.changeHandler}
                    size="sm"
                    label="Dirección"
                  />
                </MDBCol>
                <MDBCol
                  size="12"
                  sm="6"
                  md="6"
                  lg="6"
                  xl="6"
                  className="text-right mt-4"
                >
                  <XInput
                    style={{ margin: "0" }}
                    id={"direccion_2"}
                    key={"direccion_2"}
                    name={"direccion_2"}
                    value={this.state.direccion_2}
                    onChange={this.changeHandler}
                    size="sm"
                    label="Referencia"
                  />
                </MDBCol>

                <MDBCol
                  size="12"
                  sm="6"
                  md="6"
                  lg="6"
                  xl="6"
                  className="text-right mt-4"
                >
                  <XInput
                    style={{ margin: "0" }}
                    id={"latitude"}
                    key={"latitude"}
                    name={"latitude"}
                    value={this.state.latitude}
                    onChange={this.changeHandler}
                    size="sm"
                    label="Latitud"
                  />
                </MDBCol>
                <MDBCol
                  size="12"
                  sm="6"
                  md="6"
                  lg="6"
                  xl="6"
                  className="text-right mt-4"
                >
                  <XInput
                    style={{ margin: "0" }}
                    id={"longitude"}
                    key={"longitude"}
                    name={"longitude"}
                    value={this.state.longitude}
                    onChange={this.changeHandler}
                    size="sm"
                    label="Longitud"
                  />
                </MDBCol>
                <MDBCol
                  size="12"
                  sm="6"
                  md="6"
                  lg="6"
                  xl="6"
                  className="text-right mt-4"
                >
                  <XInput
                    style={{ margin: "0" }}
                    id={"telefono"}
                    key={"telefono"}
                    name={"telefono"}
                    value={this.state.telefono}
                    onChange={this.changeHandler}
                    size="sm"
                    label="Teléfono"
                  />
                </MDBCol>
                <MDBCol
                  size="12"
                  sm="6"
                  md="6"
                  lg="6"
                  xl="6"
                  className="text-right mt-4"
                >
                  <XInput
                    style={{ margin: "0" }}
                    id={"nit"}
                    key={"nit"}
                    name={"nit"}
                    value={this.state.nit}
                    onChange={this.changeHandler}
                    size="sm"
                    label="Nit"
                  />
                </MDBCol>
              </MDBRow>

              <MDBRow
                className="text-right"
                style={{ marginTop: 15, marginBottom: 15 }}
              >
                <MDBCol md="12">
                  <XInput
                    style={{ margin: "0" }}
                    id={"observacion"}
                    rows="2"
                    key={"observacion"}
                    name={"observacion"}
                    value={this.state.observacion}
                    onChange={this.changeHandler}
                    size="sm"
                    label="Observación"
                  />
                </MDBCol>
              </MDBRow>

              <MDBRow
                className="text-right xext-task-actions-row"
                style={{ marginTop: 15, marginBottom: 15 }}
              >
                <MDBCol md="12" className="xext-task-actions">
                  {this.state.formButtons.map((item, index) => (
                    <XBtn
                      className="xext-task-action-btn"
                      color={
                        ["primary", "success", "warning", "info", "secondary"][
                        index % 5
                        ]
                      }
                      size="md"
                      onClick={() => {
                        this.setState({
                          modal6: true,
                          optionMessage:
                            "Confirma la opcion " + item.optionname + "?",
                          optionCode: item.optioncode,
                          optionName: item.optionname,
                        });
                      }}
                      key={item.optioncode}
                    >
                      {" "}
                      {item.optionname}
                    </XBtn>
                  ))}
                </MDBCol>
              </MDBRow>
              {this.state.datos_enviados}
              {this.state.pdf_factura && (
                <MDBRow
                  className="text-center flex-center"
                  style={{ marginTop: 15, marginBottom: 15 }}
                >
                  <MDBCol md="12" lg="6" xl="4">
                    <h3>Datos de la Factura generada</h3>
                    {/*this.state.datos_enviados*/}
                    <div>
                      <embed
                        src={`data:application/pdf;base64,${this.state.pdf_factura}`}
                        type="application/pdf"
                        width="100%"
                        height="600px"
                      />
                    </div>
                  </MDBCol>
                </MDBRow>
              )}

              <MDBModal
                cascading
                centered
                isOpen={this.state.modal33}
                toggle={this.toggleModal(33)}
                size="lg"
              >
                <MDBModalBody>
                  <span className="h2-responsive mb-4">
                    {" "}
                    <MDBIcon icon="cart-arrow-down" className="mr-1" />{" "}
                    {"Facturación en linea"}
                  </span>

                  <>
                    {(this.state.metodo_pago === "TARJETA ATC" ||
                      this.state.metodo_pago === "TARJETA LINKSER" ||
                      this.state.metodo_pago_2 === "TARJETA ATC" ||
                      this.state.metodo_pago_2 === "TARJETA LINKSER") && (
                        <div className="row">
                          <div className=" col-sm-12 col-md-9">
                            <h5>Complete los datos de la tarjeta</h5>
                          </div>
                          <div className=" col-sm-12 col-md-9">
                            <div className="row">
                              <div className="col-3 col-sm-3 col-md-2">
                                <XInput
                                  id="tarjeta_1"
                                  key="tarjeta_1"
                                  name="tarjeta_1"
                                  placeHolder="0000"
                                  maxLength="4"
                                  value={this.state.tarjeta_1}
                                  onChange={this.changeHandler}
                                  size="xs"
                                />
                              </div>
                              <div
                                style={{
                                  fontSize: 16,
                                  fontWeight: "600",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                                className="col-3 col-sm-3 col-md-2"
                              >
                                {" "}
                                XXXX
                              </div>
                              <div
                                style={{
                                  fontSize: 16,
                                  fontWeight: "600",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                                className="col-3 col-sm-3 col-md-2"
                              >
                                {" "}
                                XXXX{" "}
                              </div>
                              <div className="col-3 col-sm-3 col-md-2">
                                <XInput
                                  id="tarjeta_2"
                                  key="tarjeta_2"
                                  name="tarjeta_2"
                                  placeHolder="0000"
                                  maxLength="4"
                                  value={this.state.tarjeta_2}
                                  onChange={this.changeHandler}
                                  size="xs"
                                />
                              </div>
                              <div className="col-12 col-sm-12 col-md-4"></div>
                            </div>
                          </div>
                        </div>
                      )}
                    <MDBRow className="text-right mt-3">
                      <MDBCol md="9">
                        <XInput
                          id="razon_social"
                          key="razon_social"
                          name="razon_social"
                          value={this.state.razon_social}
                          onChange={this.changeHandler}
                          size="sm"
                          label="Razón social"
                        />
                      </MDBCol>
                    </MDBRow>

                    <MDBRow className="text-right mt-3">
                      <MDBCol md="9">
                        <XInput
                          id="nit"
                          key="nit"
                          name="nit"
                          value={this.state.nit}
                          onChange={this.changeHandler}
                          size="sm"
                          label="NIT/CI"
                        />
                      </MDBCol>
                    </MDBRow>

                    <MDBRow className="text-right mt-3">
                      <MDBCol md="9">
                        <XSelect

                          key="tipo_documento"
                          id="tipo_documento"
                          color="primary"
                          getValue={this.selectHandler5}
                          options={this.state.tipos_documento}
                          label={"Tipo de Documento"}
                        />
                      </MDBCol>
                      <MDBCol md="3">
                        <XBtn
                          color="success"
                          onClick={() => {
                            //this.generateInvoice();
                            this.setState({
                              modal7: true,
                              optionMessage:
                                "¿Desea generar la factura de este pedido? Esta acción no se puede deshacer.",
                              opcion: "FACTURAR",
                            });
                          }}
                          className="w-100"
                          size="sm"
                        >
                          Generar Factura
                        </XBtn>

                        <XBtn
                          color="primary"
                          onClick={() => {
                            //this.generateInvoice(true);
                            this.setState({
                              modal7: true,
                              optionMessage:
                                "¿Está seguro de que desea realizar el bypass en este pedido? Debe completar el número de Factura",
                              opcion: "BYPASS",
                              numero_factura: "",
                            });
                          }}
                          className="w-100"
                          size="sm"
                        >
                          Realizar Bypass
                        </XBtn>

                        <XBtn
                          size="sm"
                          color="danger"
                          className="w-100"
                          onClick={() => {
                            this.setState({
                              modal33: false,
                            });
                          }}
                        >
                          Cancelar
                        </XBtn>
                      </MDBCol>
                    </MDBRow>
                  </>
                </MDBModalBody>
              </MDBModal>

              <MDBModal
                cascading
                centered
                isOpen={this.state.modal34}
                toggle={this.toggleModal(34)}
                size="lg"
              >
                <MDBModalBody>
                  <span className="h2-responsive mb-4">
                    {" "}
                    <MDBIcon icon="cart-arrow-down" className="mr-1" />{" "}
                    {"Anulación de Factura"}
                  </span>

                  <>
                    <MDBRow className="text-right mt-3">
                      <MDBCol md="9">
                        <XSelect
                          key="store"
                          style={{ margin: 0 }}
                          id="motivo"
                          color="primary"
                          getValue={this.selectHandler34}
                          options={this.state.motivos}
                          label="Motivo de la anulación"
                        />
                      </MDBCol>
                      <MDBCol md="3">
                        <XBtn
                          color="success"
                          onClick={() => {
                            this.anulateInvoice();
                          }}
                          className="w-100"
                          size="sm"
                        >
                          Anular
                        </XBtn>

                        <XBtn
                          size="sm"
                          color="danger"
                          className="w-100"
                          onClick={() => {
                            this.setState({
                              modal34: false,
                            });
                          }}
                        >
                          Cancelar
                        </XBtn>
                      </MDBCol>
                    </MDBRow>
                  </>
                </MDBModalBody>
              </MDBModal>

              <MDBModal
                cascading
                centered
                isOpen={this.state.modal6}
                toggle={this.toggleModal(6)}
                size="md"
              >
                <MDBModalBody className="text-center">
                  <span className="h4-responsive text-center text-uppercase">
                    {" "}
                    {this.state.optionMessage}
                  </span>
                  <hr />
                  <MDBRow className="text-center">
                    <MDBCol md="12">
                      <MDBBtnGroup size="sm">
                        <XBtn
                          outline
                          onClick={() => {
                            this.setState({ modal6: false });
                          }}
                          color="warning"
                        >
                          {" "}
                          <span className="h4-responsive">Cancelar</span>
                        </XBtn>
                        <XBtn
                          onClick={() => {
                            this.setState({ modal6: false });
                            this.executeTask(
                              this.state.optionCode,
                              this.state.optionName
                            );
                          }}
                          color="primary"
                        >
                          {" "}
                          <span className="h5-responsive">Aceptar</span>{" "}
                        </XBtn>
                      </MDBBtnGroup>
                    </MDBCol>
                  </MDBRow>
                </MDBModalBody>
              </MDBModal>

              <MDBModal
                cascading
                centered
                isOpen={this.state.modal4}
                toggle={this.toggleModal(4)}
                size="lg"
              >
                <MDBModalBody>
                  <span className="h2-responsive mb-2">
                    {" "}
                    <MDBIcon icon="cart-arrow-down" className="mr-1" /> Detalle
                    del pedido Previo{" "}
                  </span>

                  <p>Nombre: {this.state.customerName}</p>
                  <p>Direccion: {this.state.customerAdd}</p>
                  <p>Zona: {this.state.customerZone}</p>
                  {this.state.loadingData
                    ? ""
                    : this.state.ordersPre.map((event) => (
                      <p key={"event2" + event.id} style={{ width: "98%" }}>
                        <Event
                          id={event.id}
                          product_id={event.product_id}
                          productName={event.productName}
                          productQty={event.productQty}
                          productPrice={event.productPrice}
                          productModel={event.productModel}
                          productImage={event.productImage}
                          productSKU={event.productSKU}
                          precio={event.precio}
                          precio_lista={event.precio_lista}
                          state={event.state}
                          onDelete={null}
                          isSupervisor={this.state.isSupervisor}
                          isAdmin={this.state.isAdmin}
                        />
                      </p>
                    ))}
                </MDBModalBody>
              </MDBModal>

              <MDBModal
                cascading
                centered
                isOpen={this.state.modal3}
                toggle={this.toggleModal(3)}
                size="lg"
              >
                <MDBModalBody>
                  <span className="h2-responsive mb-4">
                    {" "}
                    <MDBIcon icon="cart-arrow-down" className="mr-1" /> Agregar
                    Producto
                  </span>

                  <>
                    <MDBRow className="text-right mt-3">
                      <MDBCol md="9">
                        <XInput
                          id="SKUcode"
                          key="SKUcode"
                          name="SKUcode"
                          value={this.state.SKUcode}
                          onChange={this.changeHandler}
                          size="sm"
                          label="Escriba el nombre o SKU"
                        />
                      </MDBCol>
                      <MDBCol md="3">
                        <XBtn
                          color="secondary"
                          onClick={() => {
                            this.searchProduct();
                          }}
                          className="mt-4"
                          size="sm"
                        >
                          Buscar
                        </XBtn>
                      </MDBCol>
                    </MDBRow>

                    {this.state.showProductsList ? (
                      <MDBTable
                        responsive
                        className="customTable"
                        bordered
                        striped
                      >
                        <MDBTableHead>
                          <tr>
                            <th>Imagen</th>
                            <th>Producto</th>
                            <th>Precio</th>
                            <th>Precio Promocional</th>
                            <th>Cantidad Disponible</th>
                            <th>Seleccionar</th>
                          </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                          {this.state.searchResults.map((item) => (
                            <tr key={"tr" + item.key}>
                              <td key={"td" + item.key}>
                                <img
                                  src={item.thumb}
                                  height="60px"
                                  width="60px"
                                  alt="thumbnail"
                                  className="img-thumbnail"
                                />
                              </td>
                              <td>{item.name}</td>
                              <td>{item.price}</td>
                              <td>
                                {!item.special ? item.price : item.special}
                              </td>
                              <td>{item.quantity}</td>
                              <td style={{ textAlign: "center" }}>
                                {item.selected}
                              </td>
                            </tr>
                          ))}
                        </MDBTableBody>
                      </MDBTable>
                    ) : (
                      <>
                        <MDBRow className="text-left">
                          <MDBCol md="12">
                            <span className="h4-responsive">
                              {" "}
                              <b>Detalle del producto seleccionado</b>{" "}
                            </span>
                          </MDBCol>
                        </MDBRow>

                        <MDBRow className="xext-product-detail align-items-start mt-2">
                          <MDBCol md="4" className="text-center">
                            <img
                              src={this.state.productImageBig}
                              alt="thumbnail"
                              className="img-thumbnail xext-detail-image"
                            />
                          </MDBCol>

                          <MDBCol md="8" className="text-left">
                            <div className="xext-detail-title">
                              {this.state.productName}
                            </div>

                            <MDBRow>
                              <MDBCol md="6">
                                <XInput
                                  id="productPrice"
                                  label="Precio"
                                  readOnly={true}
                                  name="productPrice"
                                  value={this.state.productPrice}
                                  onChange={this.changeHandler}
                                />
                              </MDBCol>
                              <MDBCol md="6">
                                <XInput
                                  label="Cantidad"
                                  id="productQty"
                                  name="productQty"
                                  readonly
                                  type="number"
                                  min="1"
                                  max={this.state.productMaxQty}
                                  value={this.state.productQty}
                                  onChange={this.changeHandler}
                                />
                              </MDBCol>
                            </MDBRow>

                            {this.getStockByStore().length > 0 && (
                              <div className="xext-stock-panel">
                                <span className="xext-stock-label">
                                  Stock disponible
                                </span>
                                <div className="xext-stock-badges">
                                  {this.getStockByStore().map((s) => (
                                    <span
                                      key={"stock_" + s.code}
                                      className={
                                        "xext-store-pill" +
                                        (s.variant === "online" ? " xext-store-pill--other" : "") +
                                        (s.available <= 0 ? " xext-store-pill--empty" : "")
                                      }
                                    >
                                      {s.available <= 0 && (
                                        <MDBIcon icon="exclamation-triangle" className="xext-stock-warning-icon" />
                                      )}
                                      {"MD-"+s.code}: {s.available}
                                    </span>
                                  ))}
                                </div>
                              </div>
                            )}

                            <div className="xext-detail-actions">
                              <XBtn
                                size="sm"
                                outline
                                color="danger"
                                onClick={() => {
                                  this.setState({
                                    showProductsList: true,
                                    /*SKUcode:"" , */ productName: "",
                                    productPrice: "",
                                    productQty: "1",
                                  });
                                }}
                              >
                                {" "}
                                <MDBIcon icon="arrow-alt-circle-left" /> Volver
                              </XBtn>

                              <XBtn
                                size="sm"
                                color="success"
                                disabled={this.state.disabledAdd}
                                onClick={() => {
                                  this.setState({
                                    modal5: true,
                                    mensaje: "Agregar este producto?",
                                    accion: "agregar",
                                  });
                                }}
                              >
                                {" "}
                                <MDBIcon icon="cart-plus" /> Agregar
                              </XBtn>
                            </div>
                          </MDBCol>
                        </MDBRow>
                      </>
                    )}
                  </>
                </MDBModalBody>
              </MDBModal>

              <MDBModal
                cascading
                centered
                isOpen={this.state.modal5}
                toggle={this.toggleModal(5)}
                size="md"
              >
                <MDBModalBody className="text-center">
                  <span className="h4-responsive text-center">
                    Esta seguro de {this.state.mensaje}
                  </span>
                  <hr />

                  {this.state.accion === "eliminar" && (() => {
                    const emptyStores = this.getDeleteWarningStores();
                    if (!emptyStores.length) return null;
                    return (
                      <div className="xext-delete-warning">
                        <MDBIcon icon="exclamation-triangle" className="xext-delete-warning-icon" />
                        <div>
                          Al eliminar este producto la tienda{" "}
                          <strong>{emptyStores.join(", ")}</strong>{" "}
                          quedaría sin productos en el pedido mixto.
                        </div>
                      </div>
                    );
                  })()}

                  <MDBRow className="text-center">
                    <MDBCol md="12">
                      <MDBBtnGroup size="sm">
                        <XBtn
                          outline
                          onClick={() => {
                            this.setState({ modal5: false });
                          }}
                          color="danger"
                          className="text-capitalize"
                        >
                          {" "}
                          <span className="h4-responsive">Cancelar</span>
                        </XBtn>
                        <XBtn
                          onClick={() => {
                            this.setState({ modal5: false });
                            if (this.state.accion === "agregar") {
                              this.addOrder();
                            } else if (
                              this.state.accion === "eliminar tarifa"
                            ) {
                              this.deleteShipping(this.state.order_id);
                            } else if (this.state.accion === "aumentar") {
                              this.handleCommitEdit(
                                this.state.id_producto,
                                "Add"
                              );
                            } else if (this.state.accion === "disminuir") {
                              this.handleCommitEdit(
                                this.state.id_producto,
                                "Rem"
                              );
                            } else if (this.state.accion === "cambiar") {
                              this.handleCommitPrice(this.state.id_producto);
                            } else if (this.state.accion === "cambiar envio") {
                              this.changeShippingType();
                            } else if (
                              this.state.accion === "actualizar costo de envio"
                            ) {
                              this.changeShippingCost();
                            } else if (
                              this.state.accion === "actualizar descuento"
                            ) {
                              this.changeDiscount();
                            } else if (this.state.accion === "cambiar pago") {
                              this.changePaymentType();
                            } else {
                              this.handleCommitDelete(this.state.id_producto);
                            }
                          }}
                          color="success"
                          className="text-capitalize"
                        >
                          {" "}
                          <span className="h4-responsive">
                            {this.state.accion}
                          </span>{" "}
                        </XBtn>
                      </MDBBtnGroup>
                    </MDBCol>
                  </MDBRow>
                </MDBModalBody>
              </MDBModal>
            </>
          )}

          <MDBModal
            cascading
            centered
            isOpen={this.state.modal7}
            toggle={this.toggleModal(7)}
            size="md"
          >
            <MDBModalBody className="text-center">
              <span className="h4-responsive text-center">
                {" "}
                {this.state.optionMessage}
              </span>
              <hr />
              {this.state.opcion === "BYPASS" && (
                <MDBRow className="text-center">
                  <MDBCol md="12">
                    <XInput
                      className="mt-3"
                      id={"numero_factura"}
                      key={"numero_factura"}
                      name={"numero_factura"}
                      value={this.state.numero_factura}
                      onChange={this.changeHandler}
                      size="sm"
                      label="Número Factura"
                    />
                  </MDBCol>
                </MDBRow>
              )}
              <MDBRow className="text-center">
                <MDBCol md="12">
                  <MDBBtnGroup size="sm">
                    <XBtn
                      outline
                      onClick={() => {
                        this.setState({ modal7: false });
                      }}
                      color="warning"
                    >
                      {" "}
                      <span className="h4-responsive">Cancelar</span>
                    </XBtn>
                    <XBtn
                      onClick={() => {
                        this.setState({ modal7: false });
                        //console.log("ejecutar");
                        if (this.state.opcion === "BYPASS") {
                          //console.log("aplicamos bypass");
                          this.generateInvoice(true);
                        } else {
                          //console.log("facturamos");
                          this.generateInvoice();
                        }
                      }}
                      color="primary"
                    >
                      {" "}
                      <span className="h5-responsive">Confirmar</span>{" "}
                    </XBtn>
                  </MDBBtnGroup>
                </MDBCol>
              </MDBRow>
            </MDBModalBody>
          </MDBModal>

          <ToastContainer
            hideprogress_Bar={true}
            newestOnTop={false}
            position={"bottom-right"}
            autoClose={3000}
          />
        </MDBContainer>
      </>
    );
  }
}

class Event extends React.Component {
  render() {
    const esPreventaItem =
      this.props.preventaStatus === true || this.props.preventaStatus === false;
    return this.props.state === "deleting" ? (
      <MDBCard
        style={{
          opacity: "0.4",
          backgroundColor: "#999",
        }}
        className="align-items-center justify-content-center xext-product-card"
      >
        <p></p>
        <div className="media mt-4 align-middle">
          <div className="media-body mb-3 mb-lg-3">
            <MDBAnimation type="rotateOut" infinite>
              <MDBIcon
                style={{
                  zIndex: "1050",
                }}
                size="2x"
                far
                icon="trash-alt"
              />
            </MDBAnimation>
          </div>
        </div>
        <p></p>
      </MDBCard>
    ) : (
      <MDBCard className="align-items-left justify-content-left xext-product-card">
        <div
          className="media mt-1 xext-product-head"
          style={{ background: this.props.isValid ? "auto" : "#ffc6c6" }}
        >
          <span className="xext-product-side">
            {this.props.isSupervisor > 0 ? (
              <div className="xext-qty-stepper">
                <button
                  type="button"
                  className={`xext-qty-btn ${this.props.productQty === 1 ? "xext-qty-del" : "xext-qty-minus"}`}
                  aria-label="Disminuir cantidad"
                  disabled={!!this.props.isExecuting}
                  onClick={() =>
                    this.props.productQty === 1
                      ? this.props.onDelete(this.props.id)
                      : this.props.onEdit(this.props.id, "disminuir")
                  }
                >
                  {this.props.productQty === 1 ? (
                    <MDBIcon icon="trash-alt" />
                  ) : (
                    <MDBIcon icon="minus" />
                  )}
                </button>
                <span className="xext-qty-value">{this.props.productQty}</span>
                <button
                  type="button"
                  className="xext-qty-btn xext-qty-plus"
                  aria-label="Aumentar cantidad"
                  disabled={!!this.props.isExecuting}
                  onClick={() => this.props.onEdit(this.props.id, "aumentar")}
                >
                  <MDBIcon icon="plus" />
                </button>
              </div>
            ) : (
              <span className="xext-qty-static">{this.props.productQty}</span>
            )}

            <img
              src={this.props.productImage}
              alt="thumbnail"
              className="img-thumbnail xext-product-image"
            />
            {this.props.onDelete === null ? (
              ""
            ) : (
              <button
                type="button"
                className="xext-product-delete"
                onClick={() => this.props.onDelete(this.props.id)}
              >
                <MDBIcon icon="trash-alt" /> Eliminar
              </button>
            )}
          </span>
          <div className="media-body mb-3 mb-lg-3 xext-product-body">
            {this.props.onPick === null ? (
              ""
            ) : (
              <>
                {/* HU06 Preventa -- mismo gate visual que externalForm04.js
                    "Picking Global": este componente Event es una copia
                    local, no compartida, asi que el fix del badge tenia que
                    replicarse aca aparte. Confirmado en vivo (2026-09-23)
                    que "Picking Individual" (TASKID 6, este form) dejaba
                    pickear un item es_preventa=1 sin llegar todavia -- el
                    mismo bug que ya se habia corregido en Picking Global. */}
                <MDBBadge
                  color={
                    this.props.preventaStatus === false
                      ? "danger"
                      : this.props.preventaStatus === true
                      ? "warning"
                      : this.props.isPicked === -1
                      ? "grey"
                      : "success"
                  }
                  style={{
                    cursor: esPreventaItem ? "not-allowed" : "pointer",
                    opacity: esPreventaItem ? 0.6 : 1,
                  }}
                  className="mr-1 float-right xext-product-pick"
                  onClick={() =>
                    esPreventaItem ? null : this.props.onPick(this.props.id)
                  }
                >
                  <MDBIcon
                    far={this.props.isPicked === -1 ? false : true}
                    size="2x"
                    icon={
                      this.props.isPicked === -1
                        ? "check-square"
                        : "check-square"
                    }
                  />
                  <span> Pick</span>
                </MDBBadge>
              </>
            )}
            <span className="h6 mt-0 font-weight-bold xext-product-title">
              {this.props.productName}
              {this.props.storePill && (
                <span className={`xext-store-pill${this.props.isOtherStore ? " xext-store-pill--other" : ""}`}>
                  {this.props.storePill}
                </span>
              )}
            </span>
            <hr className="hr-bold my-2" />
            {this.props.product_id && (
              <React.Fragment>
                <p className="font-smaller mb-0 xext-product-meta">
                  <MDBRow className="align-items-left justify-content-left">
                    <MDBCol md="12">
                      <MDBIcon icon="shopping-basket" /> Codigo:{" "}
                      {this.props.productModel}
                    </MDBCol>
                  </MDBRow>
                  <MDBRow className="align-items-left justify-content-left">
                    <MDBCol md="12">
                      <MDBIcon icon="barcode" /> SKU: {this.props.productSKU}
                      {this.props.preventaStatus === false && (
                        <span className="xext-preventa-pill xext-preventa-pill--pendiente">
                          Preventa: aun no llega · se pickea en Picking Preventa
                        </span>
                      )}
                      {this.props.preventaStatus === true && (
                        <span className="xext-preventa-pill xext-preventa-pill--confirmada">
                          Preventa: lista · se pickea en Picking Preventa
                        </span>
                      )}
                    </MDBCol>
                  </MDBRow>
                </p>
              </React.Fragment>
            )}
          </div>
        </div>
        {this.props.productQty && (
          <>
            <p className="p-2 mb-4  blue-grey lighten-5 blue-grey lighten-5 xext-product-summary">
              {
                "Cantidad: " +
                this.props.productQty +
                ", Precio lista: " +
                this.props.precio_lista + " Bs." +

                (this.props.precio > 0 ?
                  "- Precio con descuento:" + this.props.precio + " Bs." : ""
                ) +
                ", Total " +
                ((this.props.precio > 0 ? this.props.precio : this.props.precio_lista) * this.props.productQty).toFixed(2) +
                "Bs."
              }
            </p>
            {this.props.isAdmin > 0 ? (
              <form
                className="xext-price-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  this.props.onPrice(this.props.id, "cambiar");
                }}
              >
                <div className="xext-price-group">
                  <label htmlFor={"SKUPRICE_" + this.props.id}>Precio lista</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    className="form-control xui-control"
                    id={"SKUPRICE_" + this.props.id}
                    key={"SKUPRICE_" + this.props.id}
                    name={"SKUPRICE_" + this.props.id}
                    value={this.props.precio_lista}
                    onChange={this.props.handleChangePrice}
                  />
                </div>
                <div className="xext-price-group">
                  <label htmlFor={"SKUPRICEDISC_" + this.props.id}>
                    Precio desc.
                  </label>
                  <input
                    type="text"
                    inputMode="decimal"
                    className="form-control xui-control"
                    id={"SKUPRICEDISC_" + this.props.id}
                    key={"SKUPRICEDISC_" + this.props.id}
                    name={"SKUPRICEDISC_" + this.props.id}
                    value={this.props.precio}
                    onChange={this.props.handleChangePrice}
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-success xext-price-save-btn"
                  disabled={this.props.productPrice == "" ? true : false}
                  aria-label="Actualizar precio"
                >
                  <MDBIcon icon="save" />
                </button>
              </form>
            ) : (
              ""
            )}
          </>
        )}
      </MDBCard>
    );
  }
}

export default externalForm06;
